export const shikshapatriData = [
  {
    number: 1,
    sanskrit:
      "वामे यस्य स्थिता राधा श्रीश्च यस्यास्ति वक्षसि ।<br>वृन्दावनविहारं तं श्रीकृष्णं हृदि चिन्तये ।।१।।",
    gujarati:
      "શ્રીસહજાનંદ સ્વામી જે તે પોતાના સત્સંગી પ્રત્યે શિક્ષાપત્રીને લખતા થકા પ્રથમ પોતાના ઈષ્ટદેવ જે શ્રીકૃષ્ણ ભગવાન તેનું ધ્યાન રૂપ મંગળાચરણ કરે છે.<br>હું જે તે મારા હૃદયને વિષે શ્રીકૃષ્ણ ભગવાનનું ધ્યાન કરું છું; તે શ્રીકૃષ્ણ કેવા છે, તો જેના ડાબા પડખાને વિષે રાધિકાજી રહ્યાં છે અને જેના વક્ષઃ સ્થળને વિષે લક્ષ્મીજી રહ્યાં છે અને વૃંદાવનને વિષે વિહારના કરનારા છે. ।।૧।।",
  },
  {
    number: 2,
    sanskrit:
      "लिखामि सहजानन्द स्वामी सर्वान्निजाश्रितान्‌ ।<br>नानादेशस्थितान्‌ शिक्षापत्रीं वृत्तालयस्थित: ।।२।।",
    gujarati:
      "અને વૃત્તાલય ગામને વિષે રહ્યા એવા સહજાનંદ સ્વામી જે અમે તે જેતે નાના પ્રકારના જે સર્વે દેશ તેમને વિષે રહ્યા એવા જે અમારા આશ્રિત સર્વે સત્સંગી, તે પ્રત્યે શિક્ષાપત્રીને લખીએ છીએ. ।।૨।।",
  },
  {
    number: 3,
    sanskrit:
      "भ्रात्रो रामप्रतापेच्छारामयोर्धर्मजन्मनो: ।<br>यावयोध्याप्रसादाख्यरघुवीराभिधौ सुतौ ।।३।।",
    gujarati:
      "શ્રી ધર્મદેવ થકી છે જન્મ જેમનો, એવા જે અમારા ભાઈ રામપ્રતાપજી તથા ઈચ્છારામજી, તેમના પુત્ર જે અયોધ્યાપ્રસાદ નામે અને રઘુવીર નામે (જેને અમે અમારા દત્તપુત્ર કરીને સર્વે સત્સંગીના આચાર્યપણાને વિષે સ્થાપન કર્યા છે.) ।।૩।।",
  },
  {
    number: 4,
    sanskrit:
      "मुकुन्दानन्दमुख्याश्च नैष्ठिका ब्रह्मचारिण: ।<br>गृहस्थाश्च मयारामभट्टाद्या ये मदाश्रया: ।।४।।",
    gujarati:
      "તથા અમારા આશ્રિત એવા જે મુકુંદાનંદ આદિક નૈષ્ઠિક બ્રહ્મચારી તથા અમારા આશ્રિત જે મયારામ ભટ્ટ આદિક ગૃહસ્થ સત્સંગી. ।।૪।।",
  },
  {
    number: 5,
    sanskrit:
      "सधवा विधवा योषा याश्च मच्छिष्यतां गता: ।<br>मुक्तानन्दादयो ये स्यु: साधवश्चाखिला अपि ।।५।।",
    gujarati:
      "તથા અમારે આશ્રિત જે સુવાસિની અને વિધવા એવી સર્વે બાઈઓ તથા મુક્તાનંદ આદિક જે સર્વે સાધુ. ।।૫।।",
  },
  {
    number: 6,
    sanskrit:
      "स्वधर्मरक्षिका मे तै: सर्वैर्वाच्या: सदाशिष: ।<br>श्रीमन्नारायणस्मृत्या सहिता: शास्त्रसम्मता: ।।६।।",
    gujarati:
      "એ સર્વે તેમણે પોતાના ધર્મની રક્ષાના કરનારા અને શાસ્ત્રને વિષે પ્રમાણરૂપ અને શ્રીમન્નારાયણની સ્મૃતિએ સહિત એવા જે અમારા રૂડા આશીર્વાદ તે વાંચવા. ।।૬।।",
  },
  {
    number: 7,
    sanskrit:
      "एकाग्रेणैव मनसा पत्रीलेख: सहेतुक: ।<br>अवधार्योऽयमखिलै: सर्वजीवहितावह: ।।७।।",
    gujarati:
      "અને આ શિક્ષાપત્રી લખ્યાનું જે કારણ છે તે સર્વે, તેમણે એકાગ્ર મને કરીને ધારવું અને આ શિક્ષાપત્રી જે અમે લખી છે, તે સર્વેના જીવને હિતની કરનારી છે. ।।૭।।",
  },
  {
    number: 8,
    sanskrit:
      "ये पालयन्ति मनुजा: सच्छास्त्रप्रतिपादितान्‌ ।<br>सदाचारान्‌ सदा तेऽत्र परत्र  च  महासुखा: ।।८।।",
    gujarati:
      "અને શ્રીમદ્‌ ભાગવત્‌ પુરાણ આદિક જે સત્‌શાસ્ત્ર, તેમણે જીવના કલ્યાણને અર્થે પ્રતિપાદન કર્યા એવા જે અહિંસા આદિક સદાચાર, તેમને જે મનુષ્ય પાળે છે તે મનુષ્ય જે તે આ લોકને વિષે ને પરલોકને વિષે મહા સુખિયા થાય છે. ।।૮।।",
  },
  {
    number: 9,
    sanskrit:
      "तानुल्लङ्घयात्र वर्तन्ते ये तु स्वैरं कुबुद्धय: ।<br>त इहामुत्र च महल्लभन्ते कष्टमेव हि ।।९।।",
    gujarati:
      "અને તે સદાચારનું ઉલ્લંઘન કરીને જે મનુષ્ય પોતાના મનમાં આવે તેમ વર્તે છે તે તો કુબુદ્ધિવાળા છે અને આ લોક ને પરલોકને વિષે નિશ્ચય મોટા કષ્ટને જ પામે છે. ।।૯।।",
  },
  {
    number: 10,
    sanskrit:
      "अतो भवद्‌भिर्मच्छिष्यै: सावधानतयाऽखिलै: ।<br>प्रीत्यैतामनुसृत्यैव वर्तितव्यं निरन्तरम्‌ ।।१०।।",
    gujarati:
      "તે માટે અમારા શિષ્ય એવા જે તમે સર્વે તેમણે તો પ્રીતિએ કરીને આ શિક્ષાપત્રીને અનુસરીને જ નિરંતર સાવધાનપણે વર્તવું પણ આ શિક્ષાપત્રીનું ઉલ્લંઘન કરીને વર્તવું નહિ. ।।૧૦।।",
  },
  // શ્લોક ૧૧–૨૯ : સામાન્ય ધાર્મિક આચરણ
  {
    number: 11,
    sanskrit:
      "कस्यापि प्राणिनो हिंसा नैव कार्याऽत्र मामकै: ।<br>सूक्ष्मयूकामत्कुणादेरपि बुद्धया कदाचन ।।११।।",
    gujarati:
      "હવે તે વર્ત્યાની રીત કહીએ છીએ જે અમારા જે સત્સંગી તેમણે કોઈ જીવપ્રાણીમાત્રની પણ હિંસા ન કરવી અને જાણીને તો ઝીણા આવા જૂ, માંકડ, ચાંચડ આદિક જીવ તેમની પણ હિંસા કયારેય ન કરવી. ।।૧૧।।",
  },
  {
    number: 12,
    sanskrit:
      "देवतापितृयागार्थमप्यजादेश्च हिंसनम्‌ ।<br>न कर्तव्यमहिंसैव धर्म: प्रोक्तोऽस्ति यन्महान्‌ ।।१२।।",
    gujarati:
      "અને દેવતા અને પિતૃ તેના યજ્ઞને અર્થે પણ બકરાં, મૃગલાં, સસલાં, માછલાં આદિક કોઈ જીવની હિંસા ન કરવી કેમ જે અહિંસા છે તે જ મોટો ધર્મ છે એમ સર્વ શાસ્ત્રમાં કહ્યું છે. ।।૧૨।।",
  },
  {
    number: 13,
    sanskrit:
      "स्त्रिया धनस्य वा प्राप्त्यै साम्राज्यस्यापि वा क्वचित्‌  ।<br>मनुष्यस्य तु कस्यापि हिंसा कार्या न सर्वथा ।।१३।।",
    gujarati:
      "અને સ્ત્રી, ધન અને રાજ્ય તેની પ્રાપ્તિને અર્થે પણ કોઈ મનુષ્યની હિંસા તો કોઈ પ્રકારે કયારેય પણ ન જ કરવી. ।।૧૩।।",
  },
  {
    number: 14,
    sanskrit:
      "आत्मघातस्तु तीर्थेऽपि न कर्तव्यश्च न क्रुधा ।<br>अयोग्याचरणात्‌ क्वापि न विषोद्बन्धनादिना ।।१४।।",
    gujarati:
      "અને આત્મઘાત તો તીર્થને વિષે પણ ન કરવો ને ક્રોધે કરીને ન કરવો અને કયારેક કોઈ અયોગ્ય આચરણ થઈ જાય તે થકી મૂંઝાઈને પણ આત્મઘાત ન કરવો અને ઝેર ખાઈને તથા ગળે ટૂંપો ખાઈને તથા કૂવે પડીને તથા પર્વત ઉપરથી પડીને ઈત્યાદિક કોઈ રીતે આત્મઘાત ન કરવો. ।।૧૪।।",
  },
  {
    number: 15,
    sanskrit:
      "न भक्ष्यं सर्वथा मांसं यज्ञशिष्टमपि क्वचित्‌ ।<br>न पेयं च सुरामद्यमपि देवनिवेदितम्‌ ।।१५।।",
    gujarati:
      "અને જે માંસ છે તે તો યજ્ઞનું શેષ હોય તો પણ આપત્કાળમાં પણ કયારેય ન ખાવું અને ત્રણ પ્રકારની સુરા અને અગિયાર પ્રકારનું મદ્ય તે દેવતાનું નૈવેદ્ય હોય તો પણ ન પીવું. ।।૧૫।।",
  },
  {
    number: 16,
    sanskrit:
      "अकार्याचरणे क्वापि जाते स्वस्य परस्य वा ।<br>अङ्गच्छेदो न कर्तव्य: शस्त्राद्यैश्च क्रुधाऽपि वा ।।१६।।",
    gujarati:
      "અને કયારેક પોતાવતે કાંઈક અયોગ્ય આચરણ થઈ ગયું હોય અથવા કોઈ બીજા વતે અયોગ્ય આચરણ થઈ ગયું હોય તો શસ્ત્રાદિકે કરીને પોતાના અંગનું તથા બીજાના અંગનું છેદન ન કરવું અથવા ક્રોધે કરીને પણ પોતાના અંગનું તથા બીજાના અંગનું છેદન ન કરવું. ।।૧૬।।",
  },
  {
    number: 17,
    sanskrit:
      "स्तेनकर्म न कर्तव्यं धर्मार्थमपि केनचित्‌ ।<br>सस्वामिकाष्ठपुष्पादि न ग्राह्यं तदनाज्ञया ।।१७।।",
    gujarati:
      "અને ધર્મ કરવાને અર્થે પણ અમારા સત્સંગી, કોઈએ ચોરનું કર્મ ન કરવું અને ધણિયાતું જે કાષ્ઠ, પુષ્પ આદિક વસ્તુ, તે તેના ધણીની આજ્ઞા વિના ન લેવું. ।।૧૭।।",
  },
  {
    number: 18,
    sanskrit:
      "व्यभिचारो न कर्तव्य: पुम्भि: स्त्रीभिश्च मां श्रितै: ।<br>द्यूतादिव्यसनं त्याज्यं नाद्यं भङ्गादिमादकम्‌ ।।१८।।",
    gujarati:
      "અને અમારા આશ્રિત જે પુરુષ તથા સ્ત્રીઓ તેમણે વ્યભિચાર ન કરવો અને જુગટું આદિક જે વ્યસન તેનો ત્યાગ કરવો અને ભાંગ, મફર, માજમ, ગાંજો એ આદિક જે કેફ કરનાર વસ્તુ, તે ખાવી નહિ અને પીવી પણ નહિ. ।।૧૮।।",
  },
  {
    number: 19,
    sanskrit:
      "अग्राह्यान्नेन पक्वं यदन्नं तदुदकं च न ।<br>जगन्नाथपुरोऽन्यत्र ग्राह्यं कृष्णप्रसाद्यपि ।।१९।।",
    gujarati:
      "અને જેના હાથનું રાંધેલ અન્ન તથા જેના પાત્રનું જળ તે ખપતું ન હોય તેણે રાંધેલ અન્ન તથા તેમના પાત્રનું જળ તે શ્રીકૃષ્ણ ભગવાનની પ્રસાદી-ચરણામૃતના માહાત્મ્યે કરીને પણ જગન્નાથપુરી વિના અન્ય સ્થાનકને વિષે ગ્રહણ ન કરવું અને જગન્નાથપુરીને વિષે જગન્નાથજીનો પ્રસાદ લેવાય તેનું દોષ નહિ. ।।૧૯।।",
  },
  {
    number: 20,
    sanskrit:
      "मिथ्यापवाद: कस्मिंश्चिदपि स्वार्थस्य सिद्धये ।<br>नारोप्यो नापशब्दाश्च भाषणीया: कदाचन ।।२०।।",
    gujarati:
      "અને પોતાના સ્વાર્થની સિદ્ધિને અર્થે પણ કોઈને વિષે મિથ્યા અપવાદ આરોપણ ન કરવો અને કોઈને ગાળ તો કયારેય ન દેવી. ।।૨૦।।",
  },
  {
    number: 21,
    sanskrit:
      "देवतातीर्थविप्राणां  साध्वीनां  च  सतामपि ।<br>वेदानां च न कर्तव्या निन्दा श्रव्या न च क्वचित्‌ ।।२१।।",
    gujarati:
      "અને દેવતા, તીર્થ, બ્રાહ્મણ, પતિવ્રતા, સાધુ અને વેદ એમની નિંદા કયારેય ન કરવી અને ન સાંભળવી. ।।૨૧।।",
  },
  {
    number: 22,
    sanskrit:
      "देवतायै  भवेद्यस्यै  सुरामांसनिवेदनम्‌ ।<br>यत्पुरोऽजादिहिंसा च न भक्ष्यं तन्निवेदितम्‌ ।।२२।।",
    gujarati:
      "અને જે દેવતાને સુરા અને માંસનું નૈવેદ્ય થતું હોય અને વળી જે દેવતાને આગળ બકરાં આદિક જીવની હિંસા થતી હોય તે દેવતાનું નૈવેદ્ય ન ખાવું. ।।૨૨।।",
  },
  {
    number: 23,
    sanskrit:
      "दृष्ट्‌वा शिवालयादीनि देवागाराणि वर्त्मनि ।<br>प्रणम्य तानि तद्देवदर्शनं कार्यमादरात्‌ ।।२३।।",
    gujarati:
      "અને માર્ગને વિષે ચાલતે શિવાલયાદિક જે દેવમંદિર આવે તેને જોઈને તેને નમસ્કાર કરવા અને આદરથકી તે દેવનું દર્શન કરવું. ।।૨૩।।",
  },
  {
    number: 24,
    sanskrit:
      "स्ववर्णाश्रमधर्मो य: स हातव्यो न केनचित्‌ ।<br>परधर्मो न चाचर्यो न च पाषण्डकल्पित: ।।२४।।",
    gujarati:
      "અને પોતપોતાના વર્ણાશ્રમનો જે ધર્મ તે કોઈ સત્સંગીએ ત્યાગ ન કરવો અને પરધર્મનું આચરણ ન કરવું તથા પાખંડ ધર્મનું આચરણ ન કરવું તથા કલ્પિત ધર્મનું આચરણ ન કરવું. ।।૨૪।।",
  },
  {
    number: 25,
    sanskrit:
      "कृष्णभक्ते: स्वधर्माद्वा पतनं यस्य वाक्यत: ।<br>स्यात्तन्मुखान्न वै श्रव्या: कथावार्ताश्च वा प्रभो: ।।२५।।",
    gujarati:
      "અને જેના વચનને સાંભળવે કરીને શ્રીકૃષ્ણ ભગવાનની ભક્તિ ને પોતાનો ધર્મ એ બે થકી પડી જવાય તેના મુખ થકી ભગવાનની કથાવાર્તા ન સાંભળવી. ।।૨૫।।",
  },
  {
    number: 26,
    sanskrit:
      "स्वपरद्रोहजननं  सत्यं  भाष्यं  न  कर्हिचित्‌ ।<br>कृतघ्नसङ्गस्त्यक्तव्यो लुञ्चा ग्राह्या न कस्यचित्‌ ।।२६।।",
    gujarati:
      "અને જે સત્ય વચન બોલવે કરીને પોતાનો દ્રોહ થાય તથા પારકો દ્રોહ થાય એવું જે સત્ય વચન, તે કયારેય ન બોલવું અને જે કૃતઘ્ની હોય તેના સંગનો ત્યાગ કરવો અને વ્યવહારકાર્યને વિષે કોઈની લાંચ ન લેવી. ।।૨૬।।",
  },
  {
    number: 27,
    sanskrit:
      "चोरपापिव्यसनिनां सङ्ग: पाखण्डिनां तथा ।<br>कामिनां च न कर्तव्यो जनवञ्चनकर्मणाम्‌ ।।२७।।",
    gujarati:
      "અને ચોર, પાપી, વ્યસની, પાખંડી, કામી તથા કીમિયા આદિક ક્રિયાએ કરીને જનનો ઠગનારો, એ છ પ્રકારના જે મનુષ્ય તેમનો સંગ ન કરવો. ।।૨૭।।",
  },
  {
    number: 28,
    sanskrit:
      "भक्तिं वा ज्ञानमालम्ब्य स्त्रीद्रव्यरसलोलुभा: ।<br>पापे प्रवर्तमाना: स्यु: कार्यस्तेषां न सङ्गम: ।।२८।।",
    gujarati:
      "અને જે મનુષ્ય, ભક્તિનું અથવા જ્ઞાનનું આલંબન કરીને સ્ત્રી, દ્રવ્ય અને રસાસ્વાદ તેને વિષે અતિશય લોલુપ થકા પાપને વિષે પ્રવર્તતા હોય, તે મનુષ્યનો સમાગમ ન કરવો. ।।૨૮।।",
  },
  {
    number: 29,
    sanskrit:
      "कृष्णकृष्णावताराणां खण्डनं यत्र युक्तिभि: ।<br>कृतं स्यात्तानि शास्त्राणि न मान्यानि कदाचन ।।२९।।",
    gujarati:
      "અને જે શાસ્ત્રને વિષે શ્રીકૃષ્ણ ભગવાન તથા શ્રીકૃષ્ણ ભગવાનના જે વારાહાદિક અવતાર તેમનું યુક્તિએ કરીને ખંડન કર્યું હોય એવાં જે શાસ્ત્ર તે કયારેય ન માનવાંและ ન સાંભળવાં. ।।૨૯।।",
  },
  {
    number: 30,
    sanskrit:
      "अगालितं न पातव्यं पानीयं च पयस्तथा ।<br>स्नानादि नैव कर्तव्यं सूक्ष्मजन्तुमयाम्भसा ।।३०।।",
    gujarati:
      "અને ગાળ્યા વિનાનું જે જળ તથા દૂધ તે ન પીવું અને જે જળને વિષે ઝીણાં જીવ ઘણાંક હોય તે જળે કરીને સ્નાનાદિક ક્રિયા ન કરવી. ।।૩૦।।",
  },
  {
    number: 31,
    sanskrit:
      "यदौषधं च सुरया सम्पृक्तं पललेन वा ।<br>अज्ञातवृत्तवैद्येन दत्तं चाद्यं न तत्‌ क्वचित्‌ ।।३१।।",
    gujarati:
      "અને જે ઔષધ દારૂ તથા માંસ તેને યુક્ત હોય તે ઔષધ કયારેય ન ખાવું અને વળી જે વૈદ્યના આચરણને જાણતા ન હોઈએ તે વૈદ્યે આપ્યું જે ઔષધ તે પણ કયારેય ન ખાવું. ।।૩૧।।",
  },
  {
    number: 32,
    sanskrit:
      "स्थानेषु लोकशास्त्राभ्यां निषिद्धेषु कदाचन ।<br>मलमूत्रोत्सर्जनं च न कार्यं ष्ठीवनं तथा ।।३२।।",
    gujarati:
      "લોક અને શાસ્ત્ર તેમણે મળમૂત્ર કરવાને અર્થે વર્જ્યાં એવાં સ્થાનક જે જીર્ણ દેવાલય તથા નદી તળાવના આરા તથા માર્ગ તથા વાવેલું ખેતર તથા વૃક્ષની છાયા તથા ફૂલવાડી-બગીચા એ આદિક જે સ્થાનક તેમને વિષે કયારેય પણ મળમૂત્ર ન કરવું તથા થૂંકવું પણ નહિ. ।।૩૨।।",
  },
  {
    number: 33,
    sanskrit:
      "अद्वारेण  न  निर्गम्यं  प्रवेष्टव्यं  न  तेन  च ।<br>स्थाने सस्वामिके वास: कार्योऽपृष्ट्‌वा न तत्पतिम्‌ ।।३३।।",
    gujarati:
      "અને ચોરમાર્ગે કરીને પેસવું નહિ અને નીસરવું નહિ અને જે સ્થાનક ધણિયાતું હોય તે સ્થાનકને વિષે તેના ધણીને પૂછયા વિના ઉતારો ન કરવો. ।।૩૩।।",
  },
  {
    number: 34,
    sanskrit:
      "ज्ञानवार्ता श्रुतिर्नार्या मुखात्‌ कार्या न पुरुषै: ।<br>न विवाद: स्त्रिया कार्यो न राज्ञा न च तज्जनै: ।।३४।।",
    gujarati:
      "અને અમારા સત્સંગી જે પુરુષમાત્ર તેમણે બાઈ માણસના મુખથકી જ્ઞાનવાર્તા ન સાંભળવી અને સ્ત્રીઓ સાથે વિવાદ ન કરવો તથા રાજા સંગાથે તથા રાજાના માણસ સંગાથે વિવાદ ન કરવો. ।।૩૪।।",
  },
  {
    number: 35,
    sanskrit:
      "अपमानो न कर्तव्यो गुरू णां च वरीयसाम्‌ ।<br>लोके प्रतिष्ठितानां च विदुषां शस्त्रधारिणाम्‌ ।।३५।।",
    gujarati:
      "અને ગુરુનું અપમાન ન કરવું તથા જે અતિશય શ્રેષ્ઠ મનુષ્ય હોય તથા જે લોકને વિષે પ્રતિષ્ઠિત મનુષ્ય હોય તથા જે વિદ્વાન મનુષ્ય હોય તથા જે શસ્ત્રધારી મનુષ્ય હોય તે સર્વેનું અપમાન ન કરવું. ।।૩૫।।",
  },
  {
    number: 36,
    sanskrit:
      "कार्यं न सहसा किञ्चित्कार्यो धर्मस्तु सत्वरम्‌ ।<br>पाठनीयाऽधीतविद्या कार्य: सङ्गोऽन्वहं सताम्‌ ।।३६।।",
    gujarati:
      "અને વિચાર્યા વિના તત્કાળ કાંઈ કાર્ય ન કરવું અને ધર્મ સંબંધી જે કાર્ય તે તો તત્કાળ કરવું અને પોતે જે વિદ્યા ભણ્યા હોઈએ તે બીજાને ભણાવવી અને નિત્ય પ્રત્યે સાધુનો સમાગમ કરવો. ।।૩૬।।",
  },
  {
    number: 37,
    sanskrit:
      "गुरुदेवनृपेक्षार्थं  न  गम्यं  रिक्तपाणिभि: ।<br>विश्वासघातो नो कार्य:स्वश्लाघा स्वमुखेन च ।।३७।।",
    gujarati:
      "અને ગુરુ, દેવ અને રાજા એ ત્રણના દર્શનને અર્થે જ્યારે જવું ત્યારે ઠાલે હાથે ન જવું અને કોઈનો વિશ્વાસઘાત ન કરવો અને પોતાને મુખે કરીને પોતાનાં વખાણ ન કરવાં. ।।૩૭।।",
  },
  {
    number: 38,
    sanskrit:
      "यस्मिन्‌ परिहितेऽपि स्युर्दृश्यान्यङ्गानि चात्मन: ।<br>तद्दूष्यं वसनं नैव परिधार्यं मदाश्रितै: ।।३८।।",
    gujarati:
      "અને જે વસ્ત્ર પહેર્યે થકે પણ પોતાનાં અંગ દેખાય તેવું જે ભૂંડું વસ્ત્ર તે અમારા સત્સંગી તેમણે ન પહેરવું. ।।૩૮।।",
  },
  {
    number: 39,
    sanskrit:
      "धर्मेण रहिता कृष्णभक्ति: कार्या न सर्वथा ।<br>अज्ञनिन्दाभयान्नैव त्याज्यं श्रीकृष्णसेवनम्‌ ।।३९।।",
    gujarati:
      "અને શ્રીકૃષ્ણ ભગવાનની જે ભક્તિ તે ધર્મે રહિત એવી કોઈ પ્રકારે ન કરવી અને અજ્ઞાની એવા જે મનુષ્ય તેમની નિંદાના ભય થકી શ્રીકૃષ્ણ ભગવાનની સેવાનો ત્યાગ કરવો જ નહિ. ।।૩૯।।",
  },
  {
    number: 40,
    sanskrit:
      "उत्सवाहेषु  नित्यं  च  कृष्णमन्दिरमागतै: ।<br>पुम्भि: स्पृश्या न वनितास्तत्र ताभिश्च पूरुषा: ।।४०।।",
    gujarati:
      "અને ઉત્સવના દિવસને વિષે તથા નિત્ય પ્રત્યે શ્રીકૃષ્ણના મંદિરમાં આવ્યા એવા જે સત્સંગી પુરુષ તેમણે તે મંદિરને વિષે સ્ત્રીઓનો સ્પર્શ ન કરવો તથા સ્ત્રીઓ તેમણે પુરુષનો સ્પર્શ ન કરવો અને મંદિરમાંથી નીસર્યા પછી પોતપોતાની રીતે વર્તવું. ।।૪૦।।",
  },
  {
    number: 41,
    sanskrit:
      "कृष्णदीक्षां गुरो: प्राप्तैस्तुलसीमालिके गले ।<br>धार्ये नित्यं चोर्ध्वपुण्ड्रं ललाटादौ द्विजातिभि: ।।४१।।",
    gujarati:
      "અને ધર્મવંશી ગુરુથકી શ્રીકૃષ્ણની દીક્ષાને પામ્યા એવા જે બ્રાહ્મણ, ક્ષત્રિય અને વૈશ્ય એ ત્રણ વર્ણના અમારા સત્સંગી તેમણે કંઠને વિષે તુલસીની બેવડી માળા નિત્યે ધારવી અને લલાટ, હૃદય અને બે હાથ એ ચારે ઠેકાણે ઊર્ધ્વપુંડ્ર તિલક કરવું. ।।૪૧।।",
  },
  {
    number: 42,
    sanskrit:
      "तत्तु गोपीचन्दनेन चन्दनेनाथवा हरे: ।<br>कार्यं पूजावशिष्टेन केशरादियुतेन च ।।४२।।",
    gujarati:
      "અને તે તિલક જે તે ગોપીચંદને કરીને કરવું અથવા ભગવાનની પૂજા કરતાં બાકી રહ્યું અને કેસર કુંકુમાદિકે યુક્ત એવું જે પ્રસાદી ચંદન તેણે કરીને તિલક કરવું. ।।૪૨।।",
  },
  {
    number: 43,
    sanskrit:
      "तन्मध्य एव कर्तव्य: पुण्ड्रद्रव्येण चन्द्रक: ।<br>कुङ्कुमेनाथवा वृत्तो राधालक्ष्मीप्रसादिना ।।४३।।",
    gujarati:
      "અને તે તિલકના મધ્યને વિષે જ ગોળ એવો જે ચાંદલો તે જે તે ગોપીચંદને કરીને કરવો અથવા રાધિકાજી અને લક્ષ્મીજી તેનું પ્રસાદી એવું જે કુંકુમ તેણે કરીને તે ચાંદલો કરવો.।।૪૩।।",
  },
  {
    number: 44,
    sanskrit:
      "सच्छूद्रा: कृष्णभक्ता ये तैस्तु मालोर्ध्वपुण्ड्रके ।<br>द्विजातिवद्धारणीये निजधर्मेषु संस्थितै: ।।४४।।",
    gujarati:
      "અને પોતાના ધર્મને વિષે રહ્યા અને શ્રીકૃષ્ણના ભક્ત એવા જે સત્શૂદ્ર તેમણે તો તુલસીની માળા અને ઊર્ધ્વપુંડ્ર તિલક તે બ્રાહ્મણ, ક્ષત્રિય, વૈશ્યની પેઠે ધારવાં. ।।૪૪।।",
  },
  {
    number: 45,
    sanskrit:
      "भक्तैस्तदितरैर्माले चन्दनादीन्धनोद्‌भवे ।<br>धार्ये कण्ठे ललाटेऽथ कार्य: केवलचन्द्रक: ।।४५।।",
    gujarati:
      "અને તે સત્શૂદ્ર થકી બીજા જે જાતિએ કરીને ઉતરતા એવા ભક્તજન તેમણે તો ચંદનાદિક કાષ્ઠની જે બેવડી માળા તે ભગવાનની પ્રસાદી કરાવીને કંઠને વિષે ધારવી અને લલાટને વિષે કેવળ ચાંદલો કરવો પણ તિલક ન કરવું. ।।૪૫।।",
  },
  {
    number: 46,
    sanskrit:
      "त्रिपुण्ड्ररुद्राक्षधृतिर्येषां स्यात्स्वकुलागता ।<br>तैस्तु विप्रादिभि: क्वापि न त्याज्या सा मदाश्रितै: ।।४६।।",
    gujarati:
      "અને જે બ્રાહ્મણાદિકને ત્રિપુંડ્ર જે આડું તિલક કરવું તથા રુદ્રાક્ષની માળા ધારવી એ બે વાનાં પોતાની કુળ પરંપરાએ કરીને ચાલ્યાં આવ્યાં હોય અને તે બ્રાહ્મણાદિક અમારા આશ્રિત થયા હોય તો પણ તેમણે તે ત્રિપુંડ્ર અને રુદ્રાક્ષનો કયારેય ત્યાગ ન કરવો. ।।૪૬।।",
  },
  {
    number: 47,
    sanskrit:
      "ऐकात्म्यमेव विज्ञेयं नारायणमहेशयो: ।<br>उभयोर्ब्रह्मरू पेण वेदेषु प्रतिपादनात्‌ ।।४७।।",
    gujarati:
      "અને નારાયણ અને શિવજી, એ બેનું એકાત્મપણું જ જાણવું કેમ જે વેદને વિષે એ બેનું બ્રહ્મરૂપે કરીને પ્રતિપાદન કર્યું છે.।।૪૭।।",
  },
  {
    number: 48,
    sanskrit:
      "शास्त्रोक्त आपद्धर्मो य: स त्वल्पापदि कर्हिचित्‌ ।<br>मदाश्रितैर्मुख्यतया ग्रहीतव्यो न मानवै: ।।४८।।",
    gujarati:
      "અને અમારા આશ્રિત જે મનુષ્ય તેમણે શાસ્ત્રે કહ્યો જે આપદ્ધર્મ તે અલ્પ આપત્કાળને વિષે મુખ્યપણે કરીને કયારેય ગ્રહણ ન કરવો.।।૪૮।।",
  },
  {
    number: 49,
    sanskrit:
      "प्रत्यहं तु प्रबोद्धव्यं पूर्वमेवोदयाद्रवे: ।<br>विधाय कृष्णस्मरणं कार्य: शौचविधिस्तत: ।।४९।।",
    gujarati:
      "અને અમારા સત્સંગી, તેમણે નિત્ય સૂર્ય ઊગ્યાથી પ્રથમ જ જાગવું અને શ્રીકૃષ્ણ ભગવાનનું સ્મરણ કરીને પછી શૌચવિધિ કરવા જવું. ।।૪૯।।",
  },
  {
    number: 50,
    sanskrit:
      "उपविश्यैव चैकत्र कर्तव्यं दन्तधावनम्‌ ।<br>स्नात्वा शुच्यम्बुना धौते परिधार्ये च वाससी ।।५०।।",
    gujarati:
      "અને પછી એક સ્થાનને વિષે બેસીને દાતણ કરવું અને પછી પવિત્ર જળે કરીને સ્નાન કરીને પછી ધોયેલું વસ્ત્ર એક પહેરવું અને એક ઓઢવું. ।।૫૦।।",
  },
  {
    number: 51,
    sanskrit:
      "उपविश्य तत: शुद्ध आसने शुचिभूतले ।<br>असङ्कीर्ण उपस्पृश्यं प्राङ्‌मुखं वोत्तरामुखम्‌ ।।५१।।",
    gujarati:
      "અને ત્યાર પછી પવિત્ર પૃથ્વીને વિષે પાથર્યું અને શુદ્ધ ને કોઈ બીજા આસનને અડ્યું ન હોય અને જે ઉપર સારી પેઠે બેસાય એવું જે આસન તેને વિષે પૂર્વમુખે અથવા ઉત્તરમુખે બેસીને આચમન કરવું. ।।૫૧।।",
  },
  {
    number: 52,
    sanskrit:
      "कर्तव्यमूर्ध्वपुण्ड्रं च पुम्भिरेव सचन्द्रकम्‌ ।<br>कार्य: सधवानारीभिर्भाले कुङ्कुमचन्द्रक: ।।५२।।",
    gujarati:
      "અને પછી સત્સંગી પુરુષમાત્રને ચાંદલે સહિત ઊર્ધ્વપુંડ્ર તિલક કરવું અને સુવાસિની જે સ્ત્રીઓ તેમણે તો પોતાના ભાલને વિષે કુંકુમનો ચાંદલો કરવો. ।।૫૨।।",
  },
  {
    number: 53,
    sanskrit:
      "पुण्ड्रं वा चन्द्रको भाले न कार्यो मृतनाथया ।<br>मनसा पूजनं कार्यं तत: कृष्णस्य चाखिलै: ।।५३।।",
    gujarati:
      "અને તે વિધવા સ્ત્રીઓ માત્રને પોતાના ભાલને વિષે તિલક ન કરવું ને ચાંદલો પણ ન કરવો અને તે પછી તે સર્વે જે અમારા સત્સંગી તેમણે મનમાં કરીને કલ્પ્યાં જે ચંદન અને પુષ્પાદિક ઉપચાર તેણે કરીને શ્રીકૃષ્ણ ભગવાનની માનસી પૂજા કરવી. ।।૫૩।।",
  },
  {
    number: 54,
    sanskrit:
      "प्रणम्य राधाकृष्णस्य लेख्यार्चां तत आदरात्‌ ।<br>शक्त्या जपित्वा तन्मन्त्रं कर्तव्यं व्यावहारिकम्‌ ।।५४।।",
    gujarati:
      "અને તે પછી શ્રીરાધાકૃષ્ણની જે ચિત્ર પ્રતિમા તેનું આદરથકી દર્શન કરીને નમસ્કાર કરીને પછી પોતાના સામર્થ્ય પ્રમાણે શ્રીકૃષ્ણનો જે અષ્ટાક્ષર મંત્ર તેનો જપ કરીને તે પછી પોતાનું વ્યાવહારિક કામકાજ કરવું. ।।૫૪।।",
  },
  {
    number: 55,
    sanskrit:
      "ये त्वम्बरीषवद्‌भक्ता: स्युरिहात्मनिवेदिन: ।<br>तैश्च मानसपूजान्तं कार्यमुक्तक्रमेण वै ।।५५।।",
    gujarati:
      "અને જે અમારા સત્સંગીમાં અંબરીષ રાજાની પેઠે આત્મનિવેદી એવા ઉત્તમ ભક્ત હોય તેમણે પણ પ્રથમ કહ્યું તેવી રીતે અનુક્રમે કરીને માનસી પૂજા પર્યન્ત સર્વે ક્રિયા કરવી. ।।૫૫।।",
  },
  {
    number: 56,
    sanskrit:
      "शैली वा धातुजा मूर्ति: शालग्रामोऽर्च्य एव तै: ।<br>द्रव्यैर्यथाप्तै: कृष्णस्य जप्योऽथाष्टाक्षरो मनु: ।।५६।।",
    gujarati:
      "અને તેજે આત્મનિવેદી ભક્ત તેમણે પાષાણની અથવા ધાતુની જે શ્રીકૃષ્ણ ભગવાનની પ્રતિમા અથવા શાલિગ્રામ તેની જે પૂજા, તે દેશકાળને અનુસરીને પોતાના સામર્થ્ય પ્રમાણે પ્રાપ્ત થયાં જે ચંદન, પુષ્પ, ફળાદિક વસ્તુ તેણે કરીને કરવી અને પછી શ્રીકૃષ્ણ ભગવાનનો જે અષ્ટાક્ષર મંત્ર તેનો જપ કરવો. ।।૫૬।।",
  },
  {
    number: 57,
    sanskrit:
      "स्तोत्रादेरथ कृष्णस्य पाठ: कार्य: स्वशक्तित: ।<br>तथानधीतगीर्वाणै: कार्यं तन्नामकीर्तनम्‌ ।।५७।।",
    gujarati:
      "અને તે પછી શ્રીકૃષ્ણ ભગવાનનાં જે સ્તોત્ર અથવા ગ્રંથ તેનો જે પાઠ તે પોતાના સામર્થ્ય પ્રમાણે કરવો અને જે સંસ્કૃત ન ભણ્યા હોય તેમણે શ્રીકૃષ્ણ ભગવાનનું નામ કીર્તન કરવું. ।।૫૭।।",
  },
  {
    number: 58,
    sanskrit:
      "हरेर्विधाय नैवेद्यं भोज्यं प्रासादिकं तत: ।<br>कृष्णसेवापरै:प्रीत्या भवितव्यं च तै: सदा ।।५८।।",
    gujarati:
      "અને પછી શ્રીકૃષ્ણભગવાનને નૈવેદ્ય કરીને પછી તે પ્રસાદી એવું જે અન્ન તે જમવું અને તે જે આત્મનિવેદી વૈષ્ણવ, તેમણે સર્વકાળને વિષે પ્રીતિએ કરીને શ્રીકૃષ્ણ ભગવાનની સેવાપરાયણ થવું. ।।૫૮।।",
  },
  {
    number: 59,
    sanskrit:
      "प्रोक्तास्ते निर्गुणा भक्ता निर्गुणस्य हरेर्यत: ।<br>सम्बन्धात्तत्क्रिया: सर्वा भवन्त्येव हि निर्गुणा: ।।५९।।",
    gujarati:
      "અને નિર્ગુણ કહેતાં માયાના જે સત્ત્વાદિક ત્રણ ગુણ તેને રહિત એવા જે શ્રીકૃષ્ણ ભગવાન તેના સંબંધ થકી તે આત્મનિવેદી ભક્તની જે સર્વે ક્રિયા તે નિર્ગુણ થાય છે. તે હેતુ માટે તે આત્મનિવેદી ભક્ત જે તે નિર્ગુણ કહ્યા છે. ।।૫૯।।",
  },
  {
    number: 60,
    sanskrit:
      "भक्तैरेतैस्तु कृष्णायानर्पितं वार्यपि क्वचित्‌ ।<br>न पेयं नैव भक्ष्यं च पत्रकन्दफलाद्यपि ।।६०।।",
    gujarati:
      "અને એ જે આત્મનિવેદી ભક્ત તેમણે શ્રીકૃષ્ણ ભગવાનને અર્પણ કર્યા વિનાનું જળ પણ કયારેય ન પીવું અને પત્ર, કંદ, ફળાદિક જે વસ્તુ તે, પણ શ્રીકૃષ્ણ ભગવાનને અર્પણ કર્યા વિનાનું ન ખાવું. ।।૬૦।।",
  },
  {
    number: 61,
    sanskrit:
      "सर्वैरशक्तौ वार्धक्याद्‌गरीयस्यापदाऽथवा ।<br>भक्ताय कृष्णमन्यस्मै दत्त्वा वृत्त्यं यथाबलम्‌ ।।६१।।",
    gujarati:
      "અને વળી સર્વે જે અમારા સત્સંગી, તેમણે વૃદ્ધપણાથકી અથવા કોઈ મોટા આપત્કાળે કરીને અસમર્થપણું થઈ ગયે સતે પોતે સેવવાનું જે શ્રીકૃષ્ણનું સ્વરૂપ તે બીજા ભક્તને આપીને પોતે પોતાના સામર્થ્ય પ્રમાણે વર્તવું. ।।૬૧।।",
  },
  {
    number: 62,
    sanskrit:
      "आचार्येणैव दत्तं यद्यच्च तेन प्रतिष्ठितम्‌ ।<br>कृष्णस्वरुपं तत्सेव्यं वन्द्यमेवेतरत्तु यत्‌ ।।६२।।",
    gujarati:
      "અને જે શ્રીકૃષ્ણનું સ્વરૂપ, પોતાને સેવવાને અર્થે ધર્મવંશના જે આચાર્ય, તેમણે જ આપ્યું હોય અથવા તે આચાર્યે જે સ્વરૂપની પ્રતિષ્ઠા કરી હોય તે જ સ્વરૂપને સેવવું અને તે વિના બીજું જે શ્રીકૃષ્ણનું સ્વરૂપ તે તો નમસ્કાર કરવા યોગ્ય છે; પણ સેવવા યોગ્ય નથી. ।।૬૨।।",
  },
  {
    number: 63,
    sanskrit:
      "भगवन्मन्दिरं सर्वै: सायं गन्तव्यमन्वहम्‌ ।<br>नामसङ्कीर्तनं कार्यं तत्रोच्चै राधिकापते: ।।६३।।",
    gujarati:
      "અને અમારા જે સર્વે સત্সંગી તેમણે નિત્ય પ્રત્યે સાયંકાળે ભગવાનના મંદિર પ્રત્યે જવું અને તે મંદિરને વિષે શ્રીરાધિકાજીના પતિ એવા જે શ્રીકૃષ્ણ ભગવાન તેના નામનું ઉચ્ચ સ્વરે કરીને કીર્તન કરવું. ।।૬૩।।",
  },
  {
    number: 64,
    sanskrit:
      "कार्यास्तस्य कथावार्ता: श्रव्याश्च परमादरात्‌ ।<br>वादित्रसहितं कार्यं कृष्णकीर्तनमुत्सवे ।।६४।।",
    gujarati:
      "અને તે શ્રીકૃષ્ણની જે કથાવાર્તા તે પરમ આદર થકી કરવી ને સાંભળવી અને ઉત્સવને દિવસે વાજિંત્રે સહિત શ્રીકૃષ્ણનાં કીર્તન કરવાં. ।।૬૪।।",
  },
  {
    number: 65,
    sanskrit:
      "प्रत्यहं कार्यमित्थं हि सर्वैरपि मदाश्रितै: ।<br>संस्कृतप्राकृतग्रन्थाभ्यासश्चापि यथामति ।।६५।।",
    gujarati:
      "અને અમારા આશ્રિત જે સર્વે સત્સંગી, તેમણે જે પ્રકારે પૂર્વે કહ્યું એ પ્રકારે કરીને જ નિત્ય પ્રત્યે કરવું અને સંસ્કૃત અને પ્રાકૃત એવા જે સદ્‌ગ્રંથ તેમનો અભ્યાસ પણ પોતાની બુદ્ધિને અનુસારે કરવો. ।।૬૫।।",
  },
  {
    number: 66,
    sanskrit:
      "यादृशैर्यो गुणैर्युक्तस्तादृशे स तु कर्मणि ।<br>योजनीयो विचार्यैव नान्यथा तु कदाचन ।।६६।।",
    gujarati:
      "અને જે મનુષ્ય જેવા ગુણે કરીને યુક્ત હોય તે મનુષ્યને તેવા કાર્યને વિષે વિચારીને જ પ્રેરવો પણ જે કાર્યને વિષે જે યોગ્ય ન હોય તે કાર્યને વિષે તેને કયારેય ન પ્રેરવો. ।।૬૬।।",
  },
  {
    number: 67,
    sanskrit:
      "अन्नवस्त्रादिभि: सर्वे स्वकीया: परिचारका: ।<br>सम्भावनीया: सततं यथायोग्यं यथाधनम्‌ ।।६७।।",
    gujarati:
      "અને પોતાના જે સેવક હોય તે સર્વની પોતાના સામર્થ્ય પ્રમાણે અન્નવસ્ત્રાદિકે કરીને યથાયોગ્ય સંભાવના નિરંતર રાખવી. ।।૬૭।।",
  },
  {
    number: 68,
    sanskrit:
      "याद्दग्गुणो य: पुरुषस्तादृशा वचनेन स: ।<br>देशकालानुसारेण भाषणीयो न चान्यथा ।।६৮।।",
    gujarati:
      "અને જે પુરુષ એવા ગુણવાળા હોય તે પુરુષને તેવા વચને કરીને દેશકાળાનુસાર યથાયોગ્ય બોલાવવો પણ એથી બીજી રીતે ન બોલાવવો. ।।૬૮।।",
  },
  {
    number: 69,
    sanskrit:
      "गुरुभूपालवर्षिष्ठत्यागिविद्वत्तपस्विनाम्‌ ।<br>अभ्युत्थानादिना कार्य: सन्मानो विनयान्वितै: ।।६९।।",
    gujarati:
      "અને વિનયે કરીને યુક્ત એવા જે અમારા આશ્રિત સત્સંગી તેમણે ગુરુ, રાજા, અતિ વૃદ્ધ, ત્યાગી, વિદ્વાન્‌ અને તપસ્વી એ છ જણા આવે ત્યારે સન્મુખ ઊઠવું તથા આસન આપવું તથા મધુર વચને બોલાવવું ઈત્યાદિક ક્રિયાએ કરીને એમનું સન્માન કરવું. ।।૬૯।।",
  },
  {
    number: 70,
    sanskrit:
      "नोरौ कृत्वा पादमेकं गुरुदेवनृपान्तिके ।<br>उपवेश्यं सभायां च जानू बद्धवा न वाससा ।।७०।।",
    gujarati:
      "અને ગુરુ, દેવ ને રાજા એમને સમીપે તથા સભાને વિષે પગ ઉપર પગ ચઢાવીને ન બેસવું તથા વસ્ત્રે કરીને ઢીંચણને બાંધીને ન બેસવું. ।।૭૦।।",
  },
  {
    number: 71,
    sanskrit:
      "विवादो नैव कर्तव्य: स्वाचार्येण सह क्वचित्‌ ।<br>पूज्योऽन्नधनवस्त्राद्यैर्यथाशक्ति स चाखिलै: ।।७१।।",
    gujarati:
      "અને અમારા આશ્રિત જે સર્વે સત્સંગી તેમણે પોતાના આચાર્ય સંગાથે કયારેય પણ વિવાદ ન કરવો અને પોતાના સામર્થ્ય પ્રમાણે અન્ન, ધન, વસ્ત્રાદિકે કરીને તે પોતાના આચાર્યને પૂજવા. ।।૭૧।।",
  },
  {
    number: 72,
    sanskrit:
      "तमायान्तं निशम्याशु प्रत्युद्‌गन्तव्यमादरात्‌ ।<br>तस्मिन्‌ यात्यनुगम्यं च ग्रामान्तावधिं मच्छ्रितै: ।।७२।।",
    gujarati:
      "અમારા જે આશ્રિતજન, તેમણે પોતાના આચાર્યને આવતા સાંભળીને આદર થકી તત્કાળ સન્મુખ જવું અને તે આચાર્ય પોતાના ગામથી પાછા પધારે ત્યારે ગામની ભાગોળ સુધી વળાવવા જવું. ।।૭૨।।",
  },
  {
    number: 73,
    sanskrit:
      "अपि भूरिफलं कर्म धर्मापेतं भवेद्यदि ।<br>आचर्यं तर्हि तन्नैव धर्म: सर्वार्थदोऽस्ति हि ।।७३।।",
    gujarati:
      "અને ઘણુંક છે ફળ જેને વિષે એવું પણ જે કર્મ, તે જો ધર્મે રહિત હોય તો તેનું આચરણ ન જ કરવું; કેમ જે ધર્મ છે તે જ સર્વ પુરુષાર્થનો આપનારો છે માટે કોઈક ફળના લોભે કરીને ધર્મનો ત્યાગ ન કરવો. ।।૭૩।।",
  },
  {
    number: 74,
    sanskrit:
      "पूर्वैर्महद्भिरपि यदधर्माचरणं क्वचित्‌ ।<br>कृतं स्यात्तत्तु न ग्राह्यं ग्राह्यो धर्मस्तु तत्कृत: ।।७४।।",
    gujarati:
      "અને પૂર્વે થયા જે મોટા પુરુષ તેમણે પણ જો કયારેય અધર્માચરણ કર્યું હોય તો તેનું ગ્રહણ ન કરવું અને તેમણે જે ધર્માચરણ કર્યું હોય તેનું ગ્રહણ કરવું. ।।૭૪।।",
  },
  {
    number: 75,
    sanskrit:
      "गुह्यवार्ता तु कस्यापि प्रकाश्या नैव कुत्रचित्‌ ।<br>समदृष्टया न कार्यश्च यथार्हार्चाव्यतिक्रम: ।।७५।।",
    gujarati:
      "અને કોઈની પણ જે ગુહ્યવાર્તા તે તો કોઈ ઠેકાણે પણ પ્રકાશ કરવી જ નહિ ને જે જીવનું જેવી રીતે સન્માન કરવું ઘટતું હોય તેનું તેવી રીતે જ સન્માન કરવું પણ સમદૃષ્ટિએ કરીને એ મર્યાદાનું ઉલ્લંઘન કરવું નહિ. ।।૭૫।।",
  },
  {
    number: 76,
    sanskrit:
      "विशेषनियमो धार्यश्चातुर्मास्येऽखिलैरपि ।<br>एकस्मिन्‌ श्रावणे मासि स त्वशक्तैस्तु मानवै: ।।७६।।",
    gujarati:
      "અને અમારા જે સર્વે સત્સંગી તેમણે ચાતુર્માસને વિષે વિશેષ નિયમ ધારવો અને જે મનુષ્ય અસમર્થ હોય તેમણે તો એક શ્રાવણ માસને વિષે વિશેષ નિયમ ધારવો. ।।૭૬।।",
  },
  {
    number: 77,
    sanskrit:
      "विष्णो: कथाया: श्रवणं वाचनं गुणकीर्तनम्‌ ।<br>महापूजा मन्त्रजप: स्तोत्रपाठ: प्रदक्षिणा: ।।७७।।",
    gujarati:
      "અને તે વિશેષ નિયમ તે કયા, તો ભગવાનની કથાનું શ્રવણ કરવું તથા કથા વાંચવી તથા ભગવાનના ગુણનું કીર્તન કરવું તથા પંચામૃત સ્નાને કરીને ભગવાનની મહાપૂજા કરવી તથા ભગવાનના મંત્રનો જપ કરવો તથા સ્તોત્રનો પાઠ કરવો તથા ભગવાનને પ્રદક્ષિણાઓ કરવી. ।।૭૭।।",
  },
  {
    number: 78,
    sanskrit:
      "साष्टाङ्गप्रणतिश्चेति नियमा उत्तमा मता: ।<br>एतेष्वेकतमो भक्त्या धारणीयो विशेषत: ।।७८।।",
    gujarati:
      "તથા ભગવાનને સાષ્ટાંગ નમસ્કાર કરવા. એ જે આઠ પ્રકારના નિયમ તે અમે ઉત્તમ માન્યા છે. તે માટે એ નિયમમાંથી કોઈ એક નિયમ જે તે ચોમાસાને વિષે વિશેષપણે ભક્તિએ કરીને ધારવો. ।।૭૮।।",
  },
  {
    number: 79,
    sanskrit:
      "एकादशीनां सर्वासां कर्तव्यं व्रतमादरात्‌ ।<br>कृष्णजन्मदिनानां च शिवरात्रेश्च सोत्सवम्‌ ।।७९।।",
    gujarati:
      "અને સર્વ જે એકાદશીઓ તેમનું વ્રત જે તે આદર થકી કરવું તથા શ્રીકૃષ્ણ ભગવાનના જે જન્માષ્ટમી આદિક જન્મદિવસ તેમનું વ્રત આદર થકી કરવું તથા શિવરાત્રિનું વ્રત જે તે આદર થકી કરવું અને તે વ્રતના દિવસને વિષે મોટા ઉત્સવ કરવા. ।।૭૯।।",
  },
  {
    number: 80,
    sanskrit:
      "उपवासदिने त्याज्या दिवानिद्रा प्रयत्नत: ।<br>उपवासस्तया नश्येन्मैथुनेनेव यन्नृणाम्‌ ।।८०।।",
    gujarati:
      "અને જે દિવસે વ્રતનો ઉપવાસ કર્યો હોય તે દિવસે અતિશય યત્ને કરીને દિવસની નિદ્રાનો ત્યાગ કરવો કેમ જે જેમ મૈથુને કરીને મનુષ્યના ઉપવાસનો નાશ થાય છે તેમ જ દિવસની નિદ્રાએ કરીને મનુષ્યના ઉપવાસનો નાશ થઈ જાય છે. ।।૮૦।।",
  },
  {
    number: 81,
    sanskrit:
      "सर्ववैष्णवराज श्रीवल्लभाचार्यनन्दन: ।<br>श्री विठ्ठलेश: कृतवान्‌ यं व्रतोत्सवनिर्णयम्‌ ।।८१।।",
    gujarati:
      "અને સર્વ વૈષ્ણવના રાજા એવા જે શ્રી વલ્લભાચાર્ય તેના પુત્ર જે શ્રી વિઠ્ઠલનાથજી તે જે તે જે વ્રત અને ઉત્સવના નિર્ણયને કરતા હવા. ।।૮૧।।",
  },
  {
    number: 82,
    sanskrit:
      "कार्यास्तमनुसृत्यैव सर्व एव व्रतोत्सवा: ।<br>सेवारीतिश्च कृष्णस्य ग्राह्या तदुदितैव हि ।।८२।।",
    gujarati:
      "અને તે વિઠ્ઠલનાથજીએ કર્યો જે નિર્ણય, તેને જ અનુસરીને સર્વે વ્રત ને ઉત્સવ કરવા અને તે વિઠ્ઠલનાથજીએ કહી જે શ્રીકૃષ્ણની સેવારીતિ તેનું જ ગ્રહણ કરવું. ।।૮૨।।",
  },
  {
    number: 83,
    sanskrit:
      "कर्तव्या द्वारिकामुख्यतीर्थयात्रा यथाविधि ।<br>सर्वैरपि यथाशक्ति भाव्यं दीनेषु वत्सलै: ।।८३।।",
    gujarati:
      "અને સર્વે જે અમારા આશ્રિત તેમણે દ્વારિકા આદિક જે તીર્થ તેમની યાત્રા જે તે પોતાના સામર્થ્ય પ્રમાણે યથાવિધિએ કરીને કરવી અને વળી પોતાના સામર્થ્ય પ્રમાણે દીનજનને વિષે દયાવાન થવું. ।।૮૩।।",
  },
  {
    number: 84,
    sanskrit:
      "विष्णु: शिवो गणपति: पार्वती च दिवाकर: ।<br>एता: पूज्यतया मान्या देवता: पञ्च मामकै: ।।८४।।",
    gujarati:
      "અને અમારા જે આશ્રિત,انہوںએ વિષ્ણુ, શિવ, ગણપતિ, પાર્વતી અને સૂર્ય એ પાંચ દેવ જે તે પૂજ્યપણે કરીને માનવા. ।।૮૪।।",
  },
  {
    number: 85,
    sanskrit:
      "भूताद्युपद्रवे क्वापि वर्म नारायणात्मकम्‌ ।<br>जप्यं च हनुमन्मन्त्रो जप्यो न क्षुद्रदैवत: ।।८५।।",
    gujarati:
      "અને જો કયારેક ભૂતપ્રેતાદિકનો ઉપદ્રવ થાય ત્યારે તો નારાયણ કવચનો જપ કરવો અથવા હનુમાનના મંત્રનો જપ કરવો પણ એ વિના બીજા કોઈ ક્ષુદ્ર દેવના સ્તોત્ર અને મંત્રનો જપ ન કરવો. ।।૮૫।।",
  },
  {
    number: 86,
    sanskrit:
      "रवेरिन्दोश्चोपरागे जायमानेऽपरा: क्रिया: ।<br>हित्वाशु शुचिभि: सर्वै: कार्य: कृष्णमनोर्जप: ।।८६।।",
    gujarati:
      "અને સૂર્યનું ને ચંદ્રમાનું ગ્રહણ થયે સતે અમારા જે સર્વે સત્સંગી તેમણે બીજી સર્વે ક્રિયાનો તત્કાળ ત્યાગ કરીને પવિત્ર થઈને શ્રીકૃષ્ણ ભગવાનના મંત્રનો જપ કરવો. ।।૮૬।।",
  },
  {
    number: 87,
    sanskrit:
      "जातायामथ तन्मुक्तौ कृत्वा स्नानं सचेलकम्‌ ।<br>देयं दानं गृहिजनै: शक्त्याऽन्यैस्त्वर्च्य ईश्वर: ।।८७।।",
    gujarati:
      "અને તે ગ્રહણ મુકાઈ રહ્યા પછી વસ્ત્રે સહિત સ્નાન કરીને જે અમારા ગૃહસ્થ સત્સંગી હોય તેમણે પોતાના સામર્થ્ય પ્રમાણે દાન કરવું અને જે ત્યાગી હોય તેમણે ભગવાનની પૂજા કરવી. ।।૮૭।।",
  },
  {
    number: 88,
    sanskrit:
      "जन्माशौचं मृताशौचं स्वसम्बन्धानुसारत: ।<br>पालनीयं यथाशास्त्रं चातुर्वर्ण्यजनैर्मम ।।८८।।",
    gujarati:
      "અને અમારા સત્સંગી એવા જે ચારે વર્ણના મનુષ્ય તેમણે જન્મનું સૂતક તથા મરણનું સૂતક તે પોતપોતાના સંબંધને અનુસારે કરીને યથાશાસ્ત્ર પાળવું. ।।૮૮।।",
  },
  {
    number: 89,
    sanskrit:
      "भाव्यं शमदमक्षान्तिसन्तोषादिगुणान्वितै: ।<br>ब्राह्मणै: शौर्यधैर्यादिगुणोपेतैश्च बाहुजै: ।।८९।।",
    gujarati:
      "અને જે બ્રાહ્મણ વર્ણ હોય તેમણે શમ, દમ, ક્ષમા અને સંતોષ એ આદિક જે ગુણ તેમણે યુક્ત થવું અને જે ક્ષત્રિય વર્ણ હોય તેમણે શૂરવીરપણું અને ધીરજ એ આદિક જે ગુણ તેમણે યુક્ત થવું. ।।૮૯।।",
  },
  {
    number: 90,
    sanskrit:
      "वैश्यैश्च कृषिवाणिज्यकुसीदमुखवृत्तिभि: ।<br>भवितव्यं तथा शूद्रैर्द्विजसेवादिवृत्तिभि: ।।९०।।",
    gujarati:
      "અને વૈશ્ય વર્ણ હોય તેમણે કૃષિકર્મ તથા વણજ વ્યાપાર તથા વ્યાજવટો એ આદિક જે વૃત્તિઓ તેમણે કરીને વર્તવું અને જે શૂદ્ર વર્ણ હોય તેમણે બ્રાહ્મણાદિક ત્રણ વર્ણની સેવા કરવી એ આદિક જે વૃત્તિઓ તેમણે કરીને વર્તવું. ।।૯૦।।",
  },
  {
    number: 91,
    sanskrit:
      "संस्काराश्चाह्निकं श्राद्धं यथाकालं यथाधनम्‌ ।<br>स्वस्वगृह्यानुसारेण कर्तव्यं च द्विजन्मभि: ।।९१।।",
    gujarati:
      "અને જે દ્વિજ હોય તેમણે ગર્ભાધાનાદિક સંસ્કાર તથા આહ્નિક તથા શ્રાદ્ધ એ ત્રણ જે તે પોતાના  ગૃહ્યસૂત્રને અનુસારે કરીને જેવો જેનો અવસર હોય અને જેવી ધનસંપત્તિ હોય તે પ્રમાણે કરવાં. ।।૯૧।।",
  },
  {
    number: 92,
    sanskrit:
      "अज्ञानाज्ज्ञानतो वाऽपि गुरु वा लघु पातकम्‌ ।<br>क्वापि स्यात्तर्हि तत्प्रायश्चितं कार्यं स्वशक्तित: ।।९२।।",
    gujarati:
      "અને કયારેક જાણે અથવા અજાણે જો નાનું મોટું પાપ થઈ જાય તો પોતાની શક્તિ પ્રમાણે તે પાપનું પ્રાયશ્ચિત કરવું. ।।૯૨।।",
  },
  {
    number: 93,
    sanskrit:
      "वेदाश्च व्याससूत्राणि श्रीमद्‌भागवताभिधम्‌ ।<br>पुराणं भारते तु श्रीविष्णोर्नामसहस्रकम्‌ ।।९३।।",
    gujarati:
      "અને ચાર વેદ તથા વ્યાસસૂત્ર તથા શ્રીમદ્‌ ભાગવત નામે પુરાણ તથા મહાભારતને વિષે તો શ્રીવિષ્ણુસહસ્રનામ. ।।૯૩।।",
  },
  {
    number: 94,
    sanskrit:
      "तथा श्रीभगवद्‌गीता नीतिश्च विदुरोदिता ।<br>श्रीवासुदेवमाहात्म्यं स्कान्दवैष्णवखण्डगम्‌ ।।९४।।",
    gujarati:
      "તથા શ્રીભગવદ્‌ ગીતા તથા વિદુરજીએ કહેલી જે નીતિ તથા સ્કંદપુરાણનો જે વિષ્ણુખંડ તેને વિષે રહ્યું એવું જે શ્રીવાસુદેવમાહાત્મ્ય. ।।૯૪।।",
  },
  {
    number: 95,
    sanskrit:
      "धर्मशास्त्रान्तर्गता च याज्ञवल्क्यऋषे: स्मृति: ।<br>एतान्यष्ट ममेष्टानि सच्छास्त्राणि भवन्ति हि ।।९५।।",
    gujarati:
      "અને ધર્મશાસ્ત્રના મધ્યમાં રહી એવી જે યાજ્ઞવલ્કય ઋષિની સ્મૃતિ એ જે આઠ સત્શાસ્ત્ર તે અમને ઈષ્ટ છે. ।।૯૫।।",
  },
  {
    number: 96,
    sanskrit:
      "स्वहितेच्छुभिरेतानि मच्छिष्यै: सकलैरपि ।<br>श्रोतव्यान्यथ पाठयानि कथनीयानि च द्विजै: ।।९६।।",
    gujarati:
      "અને પોતાના હિતને ઈચ્છતા એવા જે અમારા સર્વે શિષ્ય તેમણે એ આઠ સત્શાસ્ત્ર જે તે સાંભળવાં અને અમારા આશ્રિત જે દ્વિજ તેમણે એ સત્શાસ્ત્ર જે તે ભણવાં તથા ભણાવવાં તથા એમની કથા કરવી. ।।૯૬।।",
  },
  {
    number: 97,
    sanskrit:
      "तत्राचारव्यवहृतिनिष्कृतानां च निर्णये ।<br>ग्राह्या मिताक्षरोपेता याज्ञवल्क्यस्य तु स्मृति: ।।९७।।",
    gujarati:
      "અને તે આઠ સચ્છાસ્ત્રમાંથી આચાર, વ્યવહાર અને પ્રાયશ્ચિત એ ત્રણનો જે નિર્ણય કરવો તેને વિષે તો મિતાક્ષરા ટીકાએ યુક્ત એવી જે યાજ્ઞવલ્કય ઋષિની સ્મૃતિનું તેનું ગ્રહણ કરવું. ।।૯૭।।",
  },
  {
    number: 98,
    sanskrit:
      "श्रीमद्‌भागवतस्यैषु स्कन्धौ दशमपञ्चमौ ।<br>सर्वाधिकतया ज्ञेयौ कृष्णमाहात्म्यबुद्धये ।।९८।।",
    gujarati:
      "અને વળી એ આઠ સચ્છાસ્ત્રને વિષે જે શ્રીમદ્‌ ભાગવત પુરાણ તેના દશમ ને પંચમ નામે જે બે સ્કંધ તે જેતે શ્રીકૃષ્ણ ભગવાનનું માહાત્મ્ય જાણવાને અર્થે સર્વથી અધિકપણે જાણવા. ।।૯૮।।",
  },
  {
    number: 99,
    sanskrit:
      "दशम: पञ्चम: स्कन्धो याज्ञवल्क्यस्य च स्मृति: ।<br>भक्तिशास्त्रं योगशास्त्रं धर्मशास्त्रं क्रमेण मे ।।९९।।",
    gujarati:
      "અને દશમસ્કંધ તથા પંચમસ્કંધ તથા યાજ્ઞવલ્કયની સ્મૃતિ, એ જે ત્રણ તે અનુક્રમે કરીને અમારું ભક્તિશાસ્ત્ર, યોગશાસ્ત્ર અને ધર્મશાસ્ત્ર છે કહેતાં, દશમસ્કંધ તે ભક્તિશાસ્ત્ર છે અને પંચમસ્કંધ તે યોગશાસ્ત્ર છે અને યાજ્ઞવલ્કયની સ્મૃતિ તે ધર્મશાસ્ત્ર છે એમ જાણવું. ।।૯૯।।",
  },
  {
    number: 100,
    sanskrit:
      "शारीरकाणां भगवद्‌गीतायाश्चावगम्यताम्‌ ।<br>रामानुजाचार्यकृतं भाष्यमाध्यात्मिकं मम ।।१००।।",
    gujarati:
      "અને શ્રી રામાનુજાચાર્યે કર્યું એવું જે વ્યાસસૂત્રનું શ્રીભાષ્ય તથા શ્રીભગવદ્‌ગીતાનું ભાષ્ય એ જે બે, તે અમારું અધ્યાત્મશાસ્ત્ર છે એમ જાણવું. ।।૧૦૦।।",
  },
  {
    number: 101,
    sanskrit:
      "एतेषु यानि वाक्यानि श्रीकृष्णस्य वृषस्य च ।<br>अत्युत्कर्षपराणि स्युस्तथा भक्तिविरागयो: ।।१०१।।",
    gujarati:
      "અને એ સર્વે સત્શાસ્ત્રને વિષે જે વચન તે જેતે શ્રીકૃષ્ણ ભગવાનનું સ્વરૂપ તથા ધર્મ તથા ભક્તિ તથા વૈરાગ્ય એ ચારના અતિ ઉત્કર્ષપણાને કહેતાં હોય. ।।૧૦૧।।",
  },
  {
    number: 102,
    sanskrit:
      "मन्तव्यानि प्रधानानि तान्येवेतरवाक्यत: ।<br>धर्मेण सहिता कृष्णभक्ति: कार्येति तद्रह: ।।१०२।।",
    gujarati:
      "તે વચન જે તે બીજાં વચન કરતાં પ્રધાનપણે માનવાં અને શ્રીકૃષ્ણ ભગવાનની ભક્તિ, તે જે તે ધર્મે સહિત જ કરવી. એવી રીતે તે સર્વે સત્શાસ્ત્રનું રહસ્ય છે. ।।૧૦૨।।",
  },
  {
    number: 103,
    sanskrit:
      "धर्मो ज्ञेय: सदाचार: श्रुतिस्मृत्युपपादित: ।<br>माहात्म्यज्ञानयुग्भूरिस्नेहो भक्तिश्च माधवे ।।१०३।।",
    gujarati:
      "અને શ્રુતિ, સ્મૃતિ તેમણે પ્રતિપાદન કર્યો એવો જે સદાચાર, તે ધર્મ જાણવો અને શ્રીકૃષ્ણ ભગવાનને વિષે માહાત્મ્યજ્ઞાને સહિત જે ઘણો સ્નેહ તે ભક્તિ જાણવી. ।।૧૦૩।।",
  },
  {
    number: 104,
    sanskrit:
      "वैराग्यं ज्ञेयमप्रीति: श्रीकृष्णेतरवस्तुषु ।<br>ज्ञानं च जीवमायेशरू पाणां सुष्ठु वेदनम्‌ ।।१०४।।",
    gujarati:
      "અને શ્રીકૃષ્ણ ભગવાન વિના અન્ય પદાર્થમાં પ્રીતિ નહિ, તે વૈરાગ્ય જાણવો અને જીવ માયા અને ઈશ્વર તેમનાં સ્વરૂપને જે રૂડી રીતે જાણવું, તેને જ્ઞાન કહીએ. ।।૧૦૪।।",
  },
  {
    number: 105,
    sanskrit:
      "हृत्स्थोऽणुसूक्ष्मश्चिद्रूपो ज्ञाता व्याप्याखिलां तनुम्‌ ।<br>ज्ञानशक्त्या स्थितो जीवो ज्ञेयोऽच्छेद्यादिलक्षण: ।।१०५।।",
    gujarati:
      "અને જે જીવ છે, તે હૃદયને વિષે રહ્યો છે ને અણુ સરખો સૂક્ષ્મ છે ને ચૈતન્યરૂપ છે ને જાણનારો છે અને પોતાની જ્ઞાનશક્તિએ કરીને નખથી શિખાપર્યંત સમગ્ર પોતાના દેહ પ્રત્યે વ્યાપીને રહ્યો છે અને અછેદ્ય, અભેદ્ય, અજર, અમર ઈત્યાદિક છે લક્ષણ જેનાં એવો જીવ છે એમ જાણવો. ।।૧૦૫।।",
  },
  {
    number: 106,
    sanskrit:
      "त्रिगुणात्मा तम: कृष्णशक्तिर्देहतदीययो: ।<br>जीवस्य चाहंममताहेतुर्मायावगम्यताम्‌ ।।१०६।।",
    gujarati:
      "અને જે માયા છે તે ત્રિગુણાત્મિકા છે ને અંધકારરૂપ છે ને શ્રીકૃષ્ણ ભગવાનની શક્તિ છે અને આ જીવને દેહ તથા દેહના જે સંબંધી, તેમને વિષે અહં મમત્વની કરાવનારી છે, એમ માયાને જાણવી. ।।૧૦૬।।",
  },
  {
    number: 107,
    sanskrit:
      "हृदये जीववज्जीवे योऽन्तर्यामितया स्थित: ।<br>ज्ञेय: स्वतन्त्र ईशोऽसौ सर्वकर्मफलप्रद: ।।१०७।।",
    gujarati:
      "અને જે ઈશ્વર છે તે જે તે જેમ હૃદયને વિષે જીવ રહ્યો છે તેમ તે જીવને વિષે અંતર્યામીપણે કરીને રહ્યા છે ને સ્વતંત્ર છે ને સર્વ જીવને કર્મફળના આપનારા છે એમ ઈશ્વરને જાણવા. ।।૧૦૭।।",
  },
  {
    number: 108,
    sanskrit:
      "स श्रीकृष्ण: परंब्रह्म भगवान्‌ पुरुषोत्तम: ।<br>उपास्य इष्टदेवो न: सर्वाविर्भावकारणम्‌ ।।१०८।।",
    gujarati:
      "અને તે ઈશ્વર તે કયા, તો પરબ્રહ્મ પુરુષોત્તમ એવા જે શ્રીકૃષ્ણ ભગવાન તે ઈશ્વર છે અને તે શ્રીકૃષ્ણ જે તે આપણા ઈષ્ટદેવ છે ને ઉપાસના કરવા યોગ્ય છે અને સર્વ અવતારના காரண છે. ।।૧૦૮।।",
  },
  {
    number: 109,
    sanskrit:
      "स राधया युतो ज्ञेयो राधाकृष्ण इति प्रभु: ।<br>रुक्मिण्या रमयोपेतो लक्ष्मीनारायण: स हि ।।१०९।।",
    gujarati:
      "અને સમર્થ એવા જે શ્રીકૃષ્ણ તે જે તે રાધિકાજીએ યુક્ત હોય ત્યારે રાધાકૃષ્ણ એવે નામે જાણવા અને રુક્મિણી રૂપ જે લક્ષ્મી તેમણે યુક્ત હોય ત્યારે લક્ષ્મીનારાયણ એવે નામે જાણવા. ।।૧૦૯।।",
  },
  {
    number: 110,
    sanskrit:
      "ज्ञेयोऽर्जुनेन युक्तोऽसौ नरनारायणाभिध: ।<br>बलभद्रादियोगेन तत्तन्नामोच्यते स च ।।११०।।",
    gujarati:
      "અને એ શ્રીકૃષ્ણ જે તે અજુર્ને યુક્ત હોય ત્યારે નરનારાયણ એવે નામે જાણવા અને વળી તે શ્રીકૃષ્ણ જેતે બળભદ્રાદિકને યોગે કરીને તે તે નામે કહેવાય છે એમ જાણવું. ।।૧૧૦।।",
  },
  {
    number: 111,
    sanskrit:
      "एते राधादयो भक्तास्तस्य स्यु: पार्श्वत: क्वचित्‌ ।<br>क्वचित्तदङ्गेऽतिस्नेहात्स तु ज्ञेयस्तदैकल: ।।१११।।",
    gujarati:
      "અને એ જે રાધાદિક ભક્ત તે જે તે કયારેક તો તે શ્રીકૃષ્ણ ભગવાનને પડખે હોય છે અને કયારેક તો અતિ સ્નેહે કરીને શ્રીકૃષ્ણ ભગવાનના અંગને વિષે રહે છે ત્યારે તો તે શ્રીકૃષ્ણ ભગવાન એકલા જ હોય એમ જાણવા. ।।૧૧૧।।",
  },
  {
    number: 112,
    sanskrit:
      "अतश्चास्य स्वरूपेषु भेदो ज्ञेयो न सर्वथा ।<br>चतुरादिभुजत्वं तु द्विबाहोस्तस्य चैच्छिकम्‌ ।।११२।।",
    gujarati:
      "એ હેતુ માટે એ શ્રીકૃષ્ણ ભગવાનનાં જે સ્વરૂપ તેમને વિષે સર્વે પ્રકારે કરીને ભેદ ન જાણવો અને ચતુર્ભુજપણું, અષ્ટભુજપણું, સહસ્રભુજપણું ઈત્યાદિક જે ભેદ જણાય છે તે તો દ્વિભુજ એવા જે તે શ્રીકૃષ્ણ તેમની ઈચ્છાએ કરીને છે એમ જાણવું. ।।૧૧૨।।",
  },
  {
    number: 113,
    sanskrit:
      "तस्यैव सर्वथा भक्ति: कर्तव्या मनुजैर्भुवि ।<br>नि:श्रेयसकरं किञ्चित्ततोऽन्यन्नेति दृश्यताम्‌ ।।११३।।",
    gujarati:
      "અને એવા જે તે શ્રીકૃષ્ણ ભગવાન તેની જે ભક્તિ તે જે તે પૃથ્વીને વિષે સર્વ મનુષ્ય તેમણે કરવી અને તે ભક્તિ થકી બીજું કલ્યાણકારી સાધન કાંઈ નથી એમ જાણવું. ।।૧૧૩।।",
  },
  {
    number: 114,
    sanskrit:
      "गुणिनां गुणवत्ताया ज्ञेयं ह्येतत्‌ परं फलम्‌ ।<br>कृष्णे भक्तिश्च सत्सङ्गोऽन्यथा यान्ति विदोऽप्यध: ।।११४।।",
    gujarati:
      "અને વિદ્યાદિક ગુણવાળા જે પુરુષ તેમના ગુણવાન પણાનું એ જ પરમ ફળ જાણવું. કયું તો જે શ્રીકૃષ્ણ ભગવાનને વિષે ભક્તિ કરવી ને સત્સંગ કરવો અને એમ ભક્તિ ને સત્સંગ એ બે વિના તો વિદ્વાન હોય તે પણ અધોગતિને પામે છે. ।।૧૧૪।।",
  },
  {
    number: 115,
    sanskrit:
      "कृष्णस्तदवताराश्च ध्येयास्तत्प्रतिमाऽपि च ।<br>न तु जीवा नृदेवाद्या भक्ता ब्रह्मविदोऽपि च ।।११५।।",
    gujarati:
      "અને શ્રીકૃષ્ણ ભગવાન તથા શ્રીકૃષ્ણ ભગવાનના જે અવતાર તે જે તે ધ્યાન કરવા યોગ્ય છે તથા શ્રીકૃષ્ણ ભગવાનની જે પ્રતિમા તે પણ ધ્યાન કરવા યોગ્ય છે; માટે એમનું ધ્યાન કરવું અને મનુષ્ય તથા દેવાદિક જે જીવ તે તો શ્રીકૃષ્ણ ભગવાનના ભક્ત હોય અને બ્રહ્મવેત્તા હોય તો પણ ધ્યાન કરવા યોગ્ય નથી માટે એમનું ધ્યાન ન કરવું. ।।૧૧૫।।",
  },
  {
    number: 116,
    sanskrit:
      "निजात्मानं ब्रह्मरू पं देहत्रयविलक्षणम्‌ ।<br>विभाव्य तेन कर्तव्या भक्ति: कृष्णस्य सर्वदा ।।११६।।",
    gujarati:
      "અને સ્થૂળ, સૂક્ષ્મ અને કારણ એ જે ત્રણ દેહ તે થકી વિલક્ષણ એવો જે પોતાનો જીવાત્મા તેને બ્રહ્મરૂપની ભાવના કરીને પછી તે બ્રહ્મરૂપે કરીને શ્રીકૃષ્ણ ભગવાનની ભક્તિ જે તે સર્વકાળને વિષે કરવી. ।।૧૧૬।।",
  },
  {
    number: 117,
    sanskrit:
      "श्रव्य: श्रीमद्‌भागवतदशमस्कन्ध आदरात्‌ ।<br>प्रत्यहं वा सकृद्वर्षे वर्षे वाच्योऽथ पण्डितै: ।।११७।।",
    gujarati:
      "અને શ્રીમદ્‌ ભાગવત પુરાણનો જે દશમસ્કંધ તે જે તે નિત્યપ્રત્યે આદર થકી સાંભળવો અથવા વર્ષોવર્ષ એકવાર સાંભળવો અને જે પંડિત હોય તેમણે નિત્ય પ્રત્યે વાંચવો અથવા વર્ષોવર્ષ એકવાર વાંચવો. ।।૧૧૭।।",
  },
  {
    number: 118,
    sanskrit:
      "कारणीया पुरश्चर्या पुण्यस्थानेऽस्य शक्तित: ।<br>विष्णुनामसहस्रादेश्चापि कार्येप्सितप्रदा ।।११८।।",
    gujarati:
      "અને એ જે દશમસ્કંધ તેનું પુરશ્ચરણ જે તે પુણ્ય સ્થાનકને વિષે પોતાના સામર્થ્ય પ્રમાણે કરવું. કરાવવું અને વળી વિષ્ણુસહસ્રનામ આદિક જે સચ્છાસ્ત્ર તેનું પુરશ્ચરણ પણ પોતાના સામર્થ્ય પ્રમાણે કરવું, કરાવવું. તે પુરશ્ચરણ કેવું છે, તો પોતાના મનવાંછિત ફળને આપે એવું છે. ।।૧૧૮।।",
  },
  {
    number: 119,
    sanskrit:
      "दैव्यामापदि कष्टायां मानुष्यां वा गदादिषु ।<br>यथा स्वपररक्षा स्यात्तथा वृत्त्यं न चान्यथा ।।११९।।",
    gujarati:
      "અને કષ્ટની દેનારી એવી કોઈ દેવસંબંધી આપદા આવી પડે તથા મનુષ્યસંબંધી આપદા આવી પડે તથા રોગાદિક આપદા આવી પડે તેને વિષે જેમ પોતાની ને બીજાની રક્ષા થાય તેમ વર્તવું પણ બીજી રીતે ન વર્તવું. ।।૧૧૯।।",
  },
  {
    number: 120,
    sanskrit:
      "देशकालवयोवित्तजातिशक्त्यनुसारत: ।<br>आचारो व्यवहारश्च निष्कृतं चावधार्यताम्‌ ।।१२०।।",
    gujarati:
      "અને આચાર, વ્યવહાર અને પ્રાયશ્ચિત એ જે ત્રણ વાનાં તે જેતે દેશ, કાળ, અવસ્થા, દ્રવ્ય, જાતિ અને સામર્થ્ય એટલાંને અનુસારે કરીને જાણવાં. ।।૧૨૦।।",
  },
  {
    number: 121,
    sanskrit:
      "मतं विशिष्टाद्वैतं मे गोलोको धाम चेप्सितम्‌ ।<br>तत्र ब्रह्मात्मना कृष्णसेवा मुक्तिश्च गम्यताम्‌ ।।१२१।।",
    gujarati:
      "અને અમારો જે મત તે વિશિષ્ટાદ્વૈત છે એમ જાણવું અને અમને પ્રિય એવું જે ધામ તે ગોલોક છે એમ જાણવું અને તે ધામને વિષે બ્રહ્મરૂપે કરીને જે શ્રીકૃષ્ણ ભગવાનની સેવા કરવી તે અમે મુક્તિ માની છે એમ જાણવું. ।।૧૨૧।।",
  },
  {
    number: 122,
    sanskrit:
      "एते साधारणा धर्मा: पुंसां स्त्रीणां च सर्वत: ।<br>मदाश्रितानां कथिता विशेषानथ कीर्तये ।।१२२।।",
    gujarati:
      "અને આ જે પૂર્વે સર્વે ધર્મ કહ્યા તે જે તે અમારા આશ્રિત જે ત્યાગી ગૃહસ્થ બાઈ ભાઈ સર્વ સત્સંગી તેમના સામાન્ય ધર્મ કહ્યા છે; કહેતાં સર્વ સત્સંગી માત્રને સરખા પાળવાના છે અને હવે એ સર્વેના જે વિશેષ ધર્મ છે તેમને પૃથક્‌ પૃથક્‌પણે કરીને કહીએ છીએ. ।।૧૨૨।।",
  },
  {
    number: 123,
    sanskrit:
      "मज्ज्येष्ठावरजभ्रातृसुताभ्यां तु कदाचन ।<br>स्वासन्नसम्बन्धहीना नोपदेश्या हि योषित: ।।१२३।।",
    gujarati:
      "હવે પ્રથમ ધર્મવંશી જે આચાર્ય અને તેમની પત્નીઓ તેમના જે વિશેષ ધર્મ તે કહીએ છીએ. અમારા મોટા ભાઈ અને નાનાભાઈ તેના પુત્ર જે અયોધ્યાપ્રસાદ અને રઘુવીર તેમણે પોતાના સમીપ સંબંધ વિનાની જે બીજી સ્ત્રીઓ તેમને મંત્ર ઉપદેશ કયારેય ન કરવો. ।।૧૨૩।।",
  },
  {
    number: 124,
    sanskrit:
      "न स्प्रष्टव्याश्च ता: क्वापि भाषणीयाश्च ता न हि ।<br>क्रौर्यं कार्यं न कस्मिंश्चिन्न्यासो रक्ष्यो न कस्यचित्‌ ।।१२४।।",
    gujarati:
      "અને તે સ્ત્રીઓને કયારેય પણ અડવું નહિ અને તે સાથે બોલવું નહિ અને કોઈ જીવને વિષે ક્રૂરપણું ન કરવું અને કોઈની થાપણ ન રાખવી. ।।૧૨૪।।",
  },
  {
    number: 125,
    sanskrit:
      "प्रतिभूत्वं न कस्यापि कार्यं च व्यावहारिके ।<br>भिक्षयापदतिक्रम्या न तु कार्यमृणं क्वचित्‌ ।।१२५।।",
    gujarati:
      "અને વ્યવહાર કાર્યને વિષે કોઇનું પણ જમાનગરું ન કરવું અને કોઈ આપત્કાળ આવી પડે તો ભિક્ષા માગીને પોતાનો નિર્વાહ કરીને તે આપત્કાળને ઉલ્લંઘવો પણ કોઈનું કરજ તો કયારેય ન કરવું. ।।૧૨૫।।",
  },
  {
    number: 126,
    sanskrit:
      "स्वशिष्यार्पितधान्यस्य कर्तव्यो विक्रयो न च ।<br>जीर्णं दत्त्वा नवीनं तु ग्राह्यं तन्नैष विक्रय: ।।१२६।।",
    gujarati:
      "અને પોતાના જે શિષ્ય તેમણે ધર્મ નિમિત્તે પોતાને આપ્યું જે અન્ન તે વેચવું નહીં અને તે અન્ન જૂનું થાય તો તે જૂનું કોઈકને દઈને નવું લેવું અને એવી રીતે જે જૂનાનું નવું કરવું તે વેચ્યું ન કહેવાય. ।।૧૨૬।।",
  },
  {
    number: 127,
    sanskrit:
      "भाद्रशुक्लचतुर्थ्यां च कार्यं विघ्नेशपूजनम्‌ ।<br>इषकृष्णचतुर्दश्यां कार्याऽर्चा च हनूमत: ।।१२७।।",
    gujarati:
      "અને ભાદરવા સુદિ ચતુર્થીને દિવસે ગણપતિની પૂજા કરવી તથા આસો વદિ ચતુર્દશીને દિવસે હનુમાનની પૂજા કરવી. ।।૧૨૭।।",
  },
  {
    number: 128,
    sanskrit:
      "मदाश्रितानां सर्वेषां धर्मरक्षणहेतवे ।<br>गुुरुत्वे स्थापिताभ्यां च ताभ्यां दीक्ष्या मुमुक्षव: ।।१२८।।",
    gujarati:
      "અને અમારે આશ્રિત જે સર્વે સત્સંગી તેમના ધર્મની રક્ષા કરવાને અર્થે એ સર્વેના ગુરુપણાને વિષે અમે સ્થાપન કર્યા એવા જે તે અયોધ્યાપ્રસાદ અને રઘુવીર તેમણે મુમુક્ષુ જનને દીક્ષા આપવી. ।।૧૨૮।।",
  },
  {
    number: 129,
    sanskrit:
      "यथाधिकारं संस्थाप्या: स्वे स्वे धर्मे निजाश्रिता: ।<br>मान्या: सन्तश्च कर्तव्य: सच्छास्त्राभ्यास आदरात्‌ ।।१२९।।",
    gujarati:
      "અને propriપોતાના આશ્રિત જે સર્વે સત્સંગી તેમને અધિકાર પ્રમાણે propriપોતાના ધર્મને વિષે રાખવા અને સાધુને આદરથકી માનવા તથા સચ્છાસ્ત્રનો અભ્યાસ આદરથકી કરવો. ।।૧૨૯।।",
  },
  {
    number: 130,
    sanskrit:
      "मया प्रतिष्ठापितानां मन्दिरेषु महत्सु च ।<br>लक्ष्मीनारायणादीनां सेवा कार्या यथाविधि ।।१३०।।",
    gujarati:
      "અને મોટાં જે મંદિર તેમને વિષે અમે સ્થાપન કર્યાં એવા જે શ્રીલક્ષ્મીનારાયણ આદિક શ્રીકૃષ્ણનાં સ્વરૂપ તેમની જે સેવા તે યથાવિધિએ કરીને કરવી. ।।૧૩૦।।",
  },
  {
    number: 131,
    sanskrit:
      "भगवन्मन्दिरं प्राप्तो योऽन्नार्थी कोऽपि मानव: ।<br>आदरात्स तु सम्भाव्यो दानेनान्नस्य शक्तित: ।।१३१।।",
    gujarati:
      "અને ભગવાનના મંદિર પ્રત્યે આવ્યો  જે હરકોઈ અન્નાર્થી મનુષ્ય તેની propriપોતાના સામર્થ્ય પ્રમાણે અન્નના દાને કરીને આદર થકી સંભાવના કરવી. ।।૧૩૧।।",
  },
  {
    number: 132,
    sanskrit:
      "संस्थाप्य विप्रं विद्वांसं पाठशालां विधाप्य च ।<br>प्रवर्तनीया सद्‌विद्या भुवि यत्सुकृतं महत्‌ ।।१३२।।",
    gujarati:
      "અને વિદ્યાર્થી ભણાવ્યાની શાળા કરાવીને પછી તેમાં એક વિદ્વાન બ્રાહ્મણને રાખીને પૃથ્વીને વિષે સદ્‌વિદ્યાની પ્રવૃત્તિ કરાવવી કેમ જે વિદ્યાદાને કરીને મોટું પુણ્ય થાય છે. ।।૧૩૨।।",
  },
  {
    number: 133,
    sanskrit:
      "अथैतयोस्तु भार्याभ्यामाज्ञया पत्युरात्मन: ।<br>कृष्णमन्त्रोपदेशश्च कर्तव्य: स्त्रीभ्य एव हि ।।१३३।।",
    gujarati:
      "અને હવે એ અયોધ્યાપ્રસાદ અને રઘુવીર એ બેની જે પત્નીઓ તેઓએ propriપોતાના પતિની આજ্ঞાએ કરીને સ્ત્રીઓને જ શ્રીકૃષ્ણના મંત્રનો ઉપદેશ કરવો પણ પુરુષને ન કરવો. ।।૧૩૩।।",
  },
  {
    number: 134,
    sanskrit:
      "स्वासन्नसम्बन्धहीना नरास्ताभ्यां तु कर्हिचित्‌ ।<br>न स्प्रष्टव्या न भाष्याश्च तेभ्यो दर्श्यं मुखं न च ।।१३४।।",
    gujarati:
      "અને વળી તે બે જણની જે પત્નીઓ તેઓએ propriપોતાના સમીપ સંબંધ વિનાના જે પુરુષ તેમનો સ્પર્શ કયારેય ન કરવો અને તેમની સાથે બોલવું નહિ ને તેમને propriપોતાનું મુખ પણ ન દેખાડવું. એવી રીતે ધર્મવંશી આચાર્ય અને તેમની પત્નીઓ તેમના જે વિશેષ ધર્મ તે કહ્યા. ।।૧૩૪।।",
  },
  {
    number: 135,
    sanskrit:
      "गृहाख्याश्रमिणो ये स्यु: पुरुषा मदुपाश्रिता: ।<br>स्वासन्नसम्बन्धहीना न स्पृश्या विधवाश्च तै: ।।१३५।।",
    gujarati:
      "હવે ગૃહસ્થાશ્રમીના જે વિશેષ ધર્મ તે કહીએ છીએ. અમારે આશ્રિત જે ગૃહસ્થાશ્રમી પુરુષ તેઓએ propriપોતાના સમીપ સંબંધ વિનાની જે વિધવા સ્ત્રીઓ તેમનો સ્પર્શ ન કરવો. ।।૧૩૫।।",
  },
  {
    number: 136,
    sanskrit:
      "मात्रा स्वस्रा दुहित्रा वा विजने तु वय:स्थया ।<br>अनापदि न तै: स्थेयं कार्यं दानं न योषित: ।।१३६।।",
    gujarati:
      "અને તે ગૃહસ્થાશ્રમી પુરુષ તેઓએ યુવાન અવસ્થાએ યુક્ત એવી જે propriપોતાની મા, બેન અને દીકરી તે સંગાથે પણ આપત્કાળ વિના એકાંતસ્થળને વિષે ન રહેવું અને propriપોતાની સ્ત્રીનું દાન કોઈને ન કરવું. ।।૧૩૬।।",
  },
  {
    number: 137,
    sanskrit:
      "प्रसङ्गो व्यवहारेण यस्या: केनापि भूपते: ।<br>भवेत्तस्या: स्त्रिया: कार्य: प्रसङ्गो नैव सर्वथा ।।१३७।।",
    gujarati:
      "અને જે સ્ત્રીને કોઈ પ્રકારના વ્યવહારે કરીને રાજાનો પ્રસંગ હોય તેવી સ્ત્રીનો જે પ્રસંગ તે કોઈ પ્રકારે પણ ન કરવો. ।।૧૩૭।।",
  },
  {
    number: 138,
    sanskrit:
      "अन्नाद्यै: शक्तितोऽभ्यर्च्यो ह्यतिथिस्तैर्गृहागत: ।<br>दैवं पैत्र्यं यथाशक्ति कर्तव्यं च यथोचितम्‌ ।।१३८।।",
    gujarati:
      "અને તે ગૃહસ્થાશ્રમી તેઓએ propriપોતાને ઘેર આવ્યો એવો જે અતિથિ તેને propriaપોતાના સામર્થ્ય પ્રમાણે અન્નાદિકે કરીને પૂજવો અને વળી હોમાદિક જે દેવકર્મ અને શ્રાદ્ધાદિક જે પિતૃકર્મ તે જે તે propriaપોતાના સામર્ધ્ય પ્રમાણે યથાવિધિ જેમ ઘટે તેમ કરવું. ।।૧૩૮।।",
  },
  {
    number: 139,
    sanskrit:
      "यावज्जीवं च शुश्रूषा कार्या मातु: पितुर्गुरो: ।<br>रोगार्तस्य मनुष्यस्य यथाशक्ति च मामकै: ।।१३९।।",
    gujarati:
      "અને અમારા આશ્રિત જે ગૃહષ્ઠ તેઓએ માતા પિતા અને ગુરુ તથા રોગાતુર એવા જે કોઈ મનુષ્ય તેમની જે સેવા તે જીવનપર્યંત propriaપોતાના સામર્થ્ય પ્રમાણે કરવી. ।।૧૩૯।।",
  },
  {
    number: 140,
    sanskrit:
      "यथाशक्त्युद्यम: कार्यो निजवर्णाश्रमोचित: ।<br>मुष्कच्छेदो न कर्तव्यो वृषस्य कृषिवृत्तिभि: ।।१४०।।",
    gujarati:
      "અને વળી propriaપોતાના વર્ણાશ્રમને ઘટિત એવો જે ઉદ્યમ તે propriaપોતાના સામર્થ્ય પ્રમાણે કરવો અને કૃષિવૃત્તિવાળા જે ગૃહષ્ઠ સત્સંગી તેઓએ બળદિયાના વૃષણનો ઉચ્છેદ ન કરવો. ।।૧૪૦।।",
  },
  {
    number: 141,
    sanskrit:
      "यथाशक्ति यथाकालं सङ्ग्रहोऽन्नधनस्य तै: ।<br>यावद्‌व्ययं च कर्तव्य: पशुमद्‌भिस्तृणस्य च ।।१४१।।",
    gujarati:
      "અને તે ગૃહષ્ઠ સત્સંગી તેઓએ propriaપોતાના સામર્થ્ય પ્રમાણે સમયને અનુસરીને જેટલો propriaપોતાના ઘરમાં વરો હોય તેટલા અન્ન દ્રવ્યનો સંગ્રહ જે તે કરવો અને જેના ઘરમાં પશુ હોય એવા જે ગૃહષ્ઠ તેઓએ propriaપોતાના સામર્થ્ય પ્રમાણે ચાર્યપૂળાનો સંગ્રહ કરવો. ।।૧૪૧।।",
  },
  {
    number: 142,
    sanskrit:
      "गवादीनां पशूनां च तृणतोयादिभिर्यदि ।<br>सम्भावनं भवेत्स्वेन रक्ष्यास्ते तर्हि नान्यथा ।।१४२।।",
    gujarati:
      "અને ગાય, બળદ, ભેંસ, ઘોડા આદિક જે પશુ તેમની તૃણ જળાદિકે કરીને propriaપોતાવતે જો સંભાવના થાય તો તે પશુને રાખવાં અને જો સંભાવના ન થાય તો ન રાખવાં. ।।૧૪૨।।",
  },
  {
    number: 143,
    sanskrit:
      "ससाक्ष्यमन्तरा लेखं पुत्रमित्रादिनाऽपि च ।<br>भूवित्तदानादानाभ्यां व्यवहार्यं न कर्हिचित्‌ ।।१४३।।",
    gujarati:
      "અને સાક્ષીએ સહિત લખત કર્યા વિના તો propriaપોતાના પુત્ર અને મિત્રાદિક સાથે પણ પૃથ્વી ને ધનના લેણદેણે કરીને વ્યવહાર જેતે કયારેય ન કરવો. ।।૧૪૩।।",
  },
  {
    number: 144,
    sanskrit:
      "कार्ये वैवाहिके स्वस्यान्यस्य वार्प्यधनस्य तु ।<br>भाषाबन्धो न कर्तव्य: ससाक्ष्यं लेखमन्तरा ।।१४४।।",
    gujarati:
      "અને propriaપોતાનું અથવા બીજાનું જે વિવાહ સંબંધી કાર્ય તેને વિષે આપવા યોગ્ય જે ધન તેનો સાક્ષીએ સહિત લખત કર્યા વિના કેવળ બોલી જ ન કરવી. ।।૧૪૪।।",
  },
  {
    number: 145,
    sanskrit:
      "आयद्रव्यानुसारेण व्यय: कार्यो हि सर्वदा ।<br>अन्यथा तु महद्‌दु:खं भवेदित्यवधार्यताम्‌ ।।१४५।।",
    gujarati:
      "અને propriaપોતાની ઉપજનું જે દ્રવ્ય તેને અનુસારે નિરંતર ખરચ કરવો પણ તે ઉપરાંત ન કરવો અને જે ઉપજ કરતાં વધારે ખરચ કરે છે તેને મોટું દુઃખ થાય છે; એમ સર્વે ગૃહષ્ઠોએ મનમાં જાણવું. ।।૧૪૫।।",
  },
  {
    number: 146,
    sanskrit:
      "द्रव्यस्यायो भवेद्यावान्‌ व्ययो वा व्यावहारिके ।<br>तौ संस्मृत्य स्वयं लेख्यौ स्वक्षरै: प्रतिवासरम्‌ ।।१४६।।",
    gujarati:
      "અને propriaપોતાના વ્યવહાર કાર્યને વિષે જેટલા ધનની ઉપજ હોય તથા જેટલો ખરચ હોય તે બેયને સંભારીને નિત્યપ્રત્યે રૂડા અક્ષરે કરીને propriaપોતે તેનું નામું લખવું.।।૧૪૬।।",
  },
  {
    number: 147,
    sanskrit:
      "निजवृत्त्युद्यमप्राप्तधनधान्यादितश्च तै: ।<br>अर्प्यो दशांश: कृष्णाय विंशोंऽशस्त्विह दुर्बलै: ।।१४७।।",
    gujarati:
      "અને તે ગૃહષ્ઠાશ્રમી સત્સંગી તેઓએ propriaપોતાની જે વૃત્તિ અને ઉદ્યમ તે થકી પામ્યું જે ધન ધાન્યાદિક તે થકી દશમો ભાગ કાઢીને શ્રીકૃષ્ણભગવાનને અર્પણ કરવો અને જે વ્યવહારે દુર્બળ હોય તેઓએ વીસમો ભાગ અર્પણ કરવો. ।।૧૪૭।।",
  },
  {
    number: 148,
    sanskrit:
      "एकादशीमुखानां च व्रतानां निजशक्तित: ।<br>उद्यापनं यथाशास्त्रं कर्तव्यं चिन्तितार्थदम्‌। ।।१४८।।",
    gujarati:
      "અને એકાદશી આદિક જે વ્રત તેમનું જે ઉદ્યાપન તે જેતે propriaપોતાના સામર્થ્ય પ્રમાણે યથાશાસ્ત્ર કરવું તે ઉદ્યાપન કેવું છે તો મનવાંછિત ફળનું આપનારું છે. ।।૧૪૮।।",
  },
  {
    number: 149,
    sanskrit:
      "कर्तव्यं कारणीयं वा श्रावणे मासि सर्वथा ।<br>बिल्वपत्रादिभि: प्रीत्या श्रीमहादेवपूजनम्‌ ।।१४९।।",
    gujarati:
      "અને શ્રાવણ માસને વિષે શ્રી મહાદેવનું પૂજન જેતે બિલ્વપત્રાદિકે કરીને પ્રીતિપૂર્વક સર્વ પ્રકારે propriaપોતે કરવું અથવા બીજા પાસે કરાવવું. ।।૧૪૯।।",
  },
  {
    number: 150,
    sanskrit:
      "स्वाचार्यान्न ऋणं ग्राह्यं श्रीकृष्णस्य च मन्दिरात्‌ ।<br>ताभ्यां स्वव्यवहारार्थं पात्रभूषांशुकादि च ।।१५०।।",
    gujarati:
      "અને propriaપોતાના જે આચાર્ય તે થકી તથા શ્રીકૃષ્ણ ભગવાનના જે મંદિર તે થકી કરજ ન કાઢવું અને વળી તે propriaપોતાના આચાર્ય થકી અને શ્રીકૃષ્ણના મંદિર થકી propriaપોતાના વ્યવહારને અર્થે પાત્ર, ઘરેણાં અને વસ્ત્રાદિક જે વસ્તુ તે માગી લાવવા નહીં. ।।૧૫૦।।",
  },
  {
    number: 151,
    sanskrit:
      "श्रीकृष्णगुरुसाधूनां दर्शनार्थं गतौ पथि ।<br>तत्स्थानेषु च न ग्राह्यं परान्नं निजपुण्यहृत्‌ ।।१५१।।",
    gujarati:
      "અને શ્રીકૃષ્ણ ભગવાન તથા propriaપોતાના ગુરુ તથા સાધુ એમના દર્શન કરવાને અર્થે ગયે સતે માર્ગને વિષે પારકું અન્ન ખાવું નહિ તથા શ્રીકૃષ્ણ ભગવાન તથા propriaપોતાના ગુરુ તથા સાધુ તેમનાં જે સ્થાનક તેમને વિષે પણ પારકું અન્ન ખાવું નહિ; કેમ જે તે પારકું અન્ન તો propriaપોતાના પુણ્યને હરી લે એવું છે; માટે propriaપોતાની ગાંઠનું ખરચ ખાવું. ।।૧૫૧।।",
  },
  {
    number: 152,
    sanskrit:
      "प्रतिज्ञातं धनं देयं यत्स्यात्तत्‌ कर्मकारिणे ।<br>न गोप्यमृणशुद्धयादि व्यवहार्यं न दुर्जनै: ।।१५२।।",
    gujarati:
      "અને propriaપોતાનું કામકાજ કરવા તેડયા જે મજૂર તેમને જેટલું ધન અથવા ધાન્ય દીધાનું કહ્યું હોય તે પ્રમાણે જ આપવું પણ તેમાંથી ઓછું ન આપવું અને પોતા પાસે કોઈ કરજ માગતો હોય અને તે કરજ દઈ ચૂકયા હોઈએ તે વાતને છાની ન રાખવી તથા propriaપોતાનો વંશ તથા કન્યાદાન તે પણ છાનું ન રાખવું અને દુષ્ટ એવા જે જન તેમની સાથે વ્યવહાર ન કરવો. ।।૧૫૨।।",
  },
  {
    number: 153,
    sanskrit:
      "दुष्कालस्य रिपूणां वा नृपस्योपद्रवेण वा ।<br>लज्जाधनप्राणनाश: प्राप्त: स्याद्यत्र सर्वथा ।।१५३।।",
    gujarati:
      "અને જે ઠેકાણે propriaપોતે રહેતા હોઈએ તે ઠેકાણે કોઈક કઠણ ભૂંડો કાળ અથવા શત્રુ અથવા રાજા તેમના ઉપદ્રવે કરીને સર્વ પ્રકારે propriaપોતાની લાજ જતી હોય કે ધનનો નાશ થતો હોય કે propriaપોતાના પ્રાણનો નાશ થતો હોય. ।।૧૫૩।।",
  },
  {
    number: 154,
    sanskrit:
      "मूलदेशोऽपि स स्वेषां सद्य एव विचक्षणै: ।<br>त्याज्यो मदाश्रितै: स्थेयं गत्वा देशान्तरं सुखम्‌ ।।१५४।।",
    gujarati:
      "અને તે જો propriaપોતાના મૂળ ગરાસનું તથા વતનનું ગામ હોય તો પણ તેનો વિવેકી એવા જે અમારા સત્સંગી ગૃહષ્ઠ તેઓએ તત્કાળ ત્યાગ કરી દેવો અને જ્યાં ઉપદ્રવ ન હોય તેવો જે બીજો દેશ તે પ્રત્યે જઈને સુખેથી રહેવું. ।।૧૫૪।।",
  },
  {
    number: 155,
    sanskrit:
      "आढयैस्तु गृहिभि: कार्या अहिंसा वैष्णवा मखा: ।<br>तीर्थेषु पर्वसु तथा भोज्या विप्राश्च साधव: ।।१५५।।",
    gujarati:
      "અને ધનાઢય એવા જે ગૃહષ્ઠ સત્સંગી તેઓએ હિંસાએ રહિત એવા જે વિષ્ણુ સંબંધી યજ્ઞ તે કરવા તથા તીર્થને વિષે તથા દ્વાદશી આદિક પર્વને વિષે બ્રાહ્મણ તથા સાધુ તેમને જમાડવા. ।।૧૫૫।।",
  },
  {
    number: 156,
    sanskrit:
      "महोत्सवा भगवत: कर्तव्या मन्दिरेषु तै: ।<br>देयानि पात्रविप्रेभ्यो दानानि विविधानि च ।।१५६।।",
    gujarati:
      "તે ધનાઢય એવા જે ગૃહષ્ઠ સત્સંગી તેઓએ ભગવાનના મંદિરને વિષે મોટા ઉત્સવ કરાવવા તથા સુપાત્ર એવા જે બ્રાહ્મણ તેમને નાનાં પ્રકારનાં દાન દેવાં. ।।૧૫૬।।",
  },
  {
    number: 157,
    sanskrit:
      "मदाश्रितैर्नृपैर्धर्मशास्त्रमाश्रित्य चाखिला: ।<br>प्रजा: स्वा: पुत्रवत्पाल्या धर्म: स्थाप्यो धरातले ।।१५७।।",
    gujarati:
      "અને અમારે આશ્રિત એવા જે સત્સંગી રાજા તેઓએ ધર્મશાસ્ત્રને આશરીને propriaપોતાના પુત્રની પેઠે propriaપોતાની પ્રજાનું પાલન કરવું ને પૃથ્વીને વિષે ધર્મનું સ્થાપન કરવું. ।।१५૭।।",
  },
  {
    number: 158,
    sanskrit:
      "राज्याङ्गोपायषड्‌वर्गा ज्ञेयास्तीर्थानि चाञ्जसा ।<br>व्यवहारविद: सभ्या दण्डयादण्डयाश्च लक्षणै: ।।१५८।।",
    gujarati:
      "અને રાજા તેઓએ રાજ્યનાં જે સાત અંગ તથા ચાર ઉપાય તથા છ ગુણ તે જેતે લક્ષણે કરીને યથાર્થપણે જાણવાં અને તીર્થ જે ચાર મોકલ્યાનાં સ્થાનક તથા વ્યવહારના જાણનારા જે સભાસદ તથા દંડવા યોગ્ય જે માણસ તથા દંડવા યોગ્ય નહિ એવા જે માણસ એ સર્વને લક્ષણે કરીને યથાર્થપણે જાણવા. ।।૧૫૮।।",
  },
  {
    number: 159,
    sanskrit:
      "सभर्तृकाभिर्नारीभि: सेव्य: स्वपतिरीशवत्‌ ।<br>अन्धो रोगी दरिद्रो वा षण्ढो वाच्यं न दुर्वच: ।।१५९।।",
    gujarati:
      "હવે સુવાસિની બાઈઓના વિશેષ ધર્મ કહીએ છીએ. અમારે આશ્રિત જે સુવાસિની બાઈઓ તેઓએ propriaપોતાનો પતિ અંધ હોય, રોગી હોય, દરિદ્રી હોય, નપુંસક હોય તો પણ તેને ઈશ્વરની પેઠે સેવવો અને તે પતિ પ્રત્યે કટુ વચન ન બોલવું. ।।૧૫૯।।",
  },
  {
    number: 160,
    sanskrit:
      "रू पयौवनयुक्तस्य गुणिनोऽन्यनरस्य तु ।<br>प्रसङ्गो नैव कर्तव्यस्ताभि: साहजिकोऽपि च ।।१६०।।",
    gujarati:
      "અને સુવાસિની સ્ત્રીઓ તેઓએ રૂપ ને યૌવન તેને યુક્ત અને ગુણવાન એવો જે અન્ય પુરુષ તેનો પ્રસંગ સહજ સ્વભાવે પણ ન કરવો. ।।૧૬૦।।",
  },
  {
    number: 161,
    sanskrit:
      "नरेक्ष्यनाभ्यूरुकुचाऽनुत्तरीया च नो भवेत्‌ ।<br>साध्वी स्त्री न च भण्डेक्षा न निर्लज्जादिसङ्गिनी ।।१६१।।",
    gujarati:
      "અને પતિવ્રતા એવી જે સુવાસિની સ્ત્રીઓ તેઓએ propriaપોતાની નાભિ, સાથળ અને છાતી તેને બીજો પુરુષ દેખે એમ ન વર્તવું અને ઓઢયાના વસ્ત્ર વિના ઉઘાડે શરીરે ન રહેવું અને ભાંડભવાઈ જોવા ન જવું અને નિર્લજ્જ એવી જે સ્ત્રીઓ તથા સ્વૈરિણી, કામિની અને પુંશ્ચલી એવી જે સ્ત્રીઓ તેમનો સંગ ન કરવો. ।।૧૬૧।।",
  },
  {
    number: 162,
    sanskrit:
      "भूषासदंशुकधृति:  परगेहोपवेशनम्‌ ।<br>त्याज्यं हास्यादि च स्त्रीभि: पत्यौ देशान्तरं गते ।।१६२।।",
    gujarati:
      "અને તે સુવાસિની સ્ત્રીઓ તેઓએ propriaપોતાનો પતિ પરદેશ ગયે સતે આભૂષણ ન ધારવાં ને રૂડાં વસ્ત્ર ન પહેરવાં ને પારકે ઘેર બેસવા ન જવું અને હાસ્ય વિનોદાદિકનો ત્યાગ કરવો. ।।૧૬૨।।",
  },
  {
    number: 163,
    sanskrit:
      "विधवाभिस्तु योषाभि: सेव्य: पतिधिया हरि: ।<br>आज्ञायां पितृपुत्रादेर्वृत्यं स्वातन्त्र्यतो न तु ।।१६३।।",
    gujarati:
      "હવે વિધવા સ્ત્રીઓના વિશેષ ધર્મ કહીએ છીએ. અમારે આશ્રિત જે વિધવા સ્ત્રીઓ તેઓએ તો પતિબુદ્ધિએ કરીને શ્રીકૃષ્ણ ભગવાનને સેવવા અને propriaપોતાના પિતા પુત્રાદિક જે સંબંધી તેમની આજ્ઞાને વિષે વર્તવું પણ સ્વતંત્રપણે ન વર્તવું. ।।૧૬૩।।",
  },
  {
    number: 164,
    sanskrit:
      "स्वासन्नसम्बन्धहीना नरा: स्पृश्या न कर्हिचित्‌ ।<br>तरुणैस्तैश्च तारुण्ये भाष्यं नावश्यकं विना ।।१६४।।",
    gujarati:
      "અને તે વિધવા સ્ત્રીઓ તેઓએ propriaપોતાના સમીપ સંબંધ વિનાના જે પુરુષ તેમનો સ્પર્શ કયારેય ન કરવો અને propriaપોતાની યુવાવસ્થાને વિષે અવશ્ય કાર્ય વિના સમીપ સંબંધ વિનાના જે યુવાન પુરુષ તેમની સાથે કયારેય પણ બોલવું નહિ. ।।૧૬૪।।",
  },
  {
    number: 165,
    sanskrit:
      "स्तनन्धयस्य नु: स्पर्शे न दोषोऽस्ति पशोरिव ।<br>आवश्यके च वृद्धस्य स्पर्शे तेन च भाषणे ।।१६५।।",
    gujarati:
      "અને ધાવણો જે બાળક તેના સ્પર્શને વિષે તો જેમ પશુને અડી જવાય અને દોષ નથી તેમ દોષ નથી અને કોઈ અવશ્યનું કામકાજ પડે તેને વિષે કોઈક વૃદ્ધ પુરુષને અડી જવાય તથા તે વૃદ્ધ સાથે બોલાય તેને વિષે દોષ નથી. ।।૧૬૫।।",
  },
  {
    number: 166,
    sanskrit:
      "विद्याऽनासन्नसम्बन्धात्ताभि: पाठया न काऽपि नु: ।<br>व्रतोपवासै: कर्तव्यो मुहुर्देहदमस्तथा ।।१६६।।",
    gujarati:
      "અને તે વિધવા સ્ત્રીઓ તેઓએ propriaપોતાના સમીપ સંબંધ વિનાના જે પુરુષ તે થકી કોઈ પણ વિદ્યા ن ભણવી ને વ્રત ઉપવાસે કરીને વારંવાર propriaપોતાના દેહનું દમન કરવું. ।।૧૬૬।।",
  },
  {
    number: 167,
    sanskrit:
      "धनं च धर्म कार्येऽपि स्वनिर्वाहोपयोगि यत्‌ ।<br>देयं ताभिर्न तत्‌ क्वापि देयं चेदधिकं तदा ।।१६७।।",
    gujarati:
      "અને તે વિધવા સ્ત્રીઓ તેઓએ propriaપોતાના ઘરમાં propriaપોતાના જીવનપર્યંત દેહનિર્વાહ થાય એટલું જ જો ધન હોય તો તે ધન જે તે ધર્મકાર્યને વિષે પણ ન આપવું અને જો તેથી અધિક હોય તો આપવું. ।।૧૬૭।।",
  },
  {
    number: 168,
    sanskrit:
      "कार्यश्च सकृदाहारस्ताभि: स्वापस्तु भूतले ।<br>मैथुनासक्तयोर्वीक्षा क्वापि कार्या न देहिनो: ।।१६८।।",
    gujarati:
      "અને વિધવા સ્ત્રીઓ તેઓએ એકવાર આહાર કરવો ને પૃથ્વીને વિષે સૂવું ને મૈથુનાસકત એવાં જે પશુપક્ષી આદિક જીવ પ્રાણીમાત્ર તેમને જોવા નહિ. ।।૧૬૮।।",
  },
  {
    number: 169,
    sanskrit:
      "वेषो न धार्यस्ताभिश्च सुवासिन्या: स्त्रियास्तथा ।<br>न्यासिन्या वीतरागाया विकृतश्च न कर्हिचित्‌ ।।१६९।।",
    gujarati:
      "અને તે વિધવા સ્ત્રીઓ તેઓએ સુવાસિની સ્ત્રીના જેવો વેષ ન ધારવો તેમજ સંન્યાસણી તથા વૈરાગણી તેના જેવો વેષ ન ધારવો અને propriaપોતાનો દેશ, કુળ અને આચાર તેને વિરુદ્ધ એવો જે વેષ તે પણ કયારેય ન ધારવો. ।।૧૬૯।।",
  },
  {
    number: 170,
    sanskrit:
      "सङ्गो न गर्भपातिन्या: स्पर्श: कार्यश्च योषित: ।<br>शृङ्गारवार्ता न नृणां कार्या: श्रव्या न वै क्वचित्‌ ।।१७०।।",
    gujarati:
      "અને ગર્ભની પાડનારી જે સ્ત્રી તેનો સંગ ન કરવો અને તેનો સ્પર્શ પણ ન કરવો અને પુરુષના શૃંગારરસ સંબંધી જે વાર્તા તે કયારેય ન કરવી અને ન સાંભળવી. ।।૧૭૦।।",
  },
  {
    number: 171,
    sanskrit:
      "निजसम्बन्धिभिरपि तारुण्ये तरुणैर्नरै: ।<br>साकं रहसि न स्थेयं ताभिरापदमन्तरा ।।१७१।।",
    gujarati:
      "અને યુવા અવસ્થાને વિષે રહી એવી જે વિધવા સ્ત્રીઓ તેઓએ યુવા અવસ્થાવાળા જે propriપોતાના સંબંધી પુરુષ તેમની સંગાથે પણ એકાંત સ્થળને વિષે આપત્કાળ પડયા વિના ન રહેવું. ।।૧૭૧।।",
  },
  {
    number: 172,
    sanskrit:
      "न होलाखेलनं कार्यं न भूषादेश्च धारणम्‌ ।<br>न धातुसूत्रयुक्सूक्ष्मवस्त्रादेरपि कर्हिचित्‌ ।।१७२।।",
    gujarati:
      "અને હોળીની રમત ન કરવી ને આભૂષણાદિકનું ધારણ ન કરવું અને સુવર્ણાદિક ધાતુના તારે યુક્ત એવાં જે ઝીણાં વસ્ત્ર તેનું ધારણ પણ કયારેય ન કરવું. ।।૧૭૨।।",
  },
  {
    number: 173,
    sanskrit:
      "सधवा विधवाभिश्च न स्नातव्यं निरम्बरम्‌ ।<br>स्वरजोदर्शनं स्त्रीभिर्गोपनीयं न सर्वथा ।।१७३।।",
    gujarati:
      "અને સુવાસિની ને વિધવા એવી જે સ્ત્રીઓ તેઓએ વસ્ત્ર પહેર્યા વિના નહાવું નહિ અને propriaપોતાનું જે રજસ્વલાપણું તે કોઈ પ્રકારે ગુપ્ત ન રાખવું. ।।૧૭૩।।",
  },
  {
    number: 174,
    sanskrit:
      "मनुष्यं चांशुकादीनि नारी क्वापि रजस्वला ।<br>दिनत्रयं स्पृशेन्नैव स्नात्वा तुर्येऽह्वि सा स्पृशेत्‌ ।।१७४।।",
    gujarati:
      "અને વળી રજસ્વલા એવી જે સુવાસિની અને વિધવા સ્ત્રીઓ તે ત્રણ દિવસ સુધી કોઈ મનુષ્યને તથા વસ્ત્રાદિકને અડે નહિ અને ચોથે દિવસે નાહીને અડવું. ।।૧૭૪।।",
  },
  {
    number: 175,
    sanskrit:
      "नैष्ठिकव्रतवन्तो ये वर्णिनो मदुपाश्रया: ।<br>तै: स्पृश्या न स्त्रियो भाष्या न च वीक्ष्याश्च ता धिया ।।१७५।।",
    gujarati:
      "હવે નૈષ્ઠિક બ્રહ્મચારીના જે વિશેષ ધર્મ તે કહીએ છીએ-અમારે આશ્રિત એવા જે નૈષ્ઠિક બ્રહ્મચારી તેઓએ સ્ત્રી માત્રનો સ્પર્શ ન કરવો અને સ્ત્રીઓ સંગાથે બોલવું નહિ અને જાણીને તે સ્ત્રીઓ સન્મુખ જોવું નહિ. ।।૧૭૫।।",
  },
  {
    number: 176,
    sanskrit:
      "तासां वार्ता न कर्तव्या न श्रव्याश्च कदाचन ।<br>तत्पादचारस्थानेषु न च स्नानादिका क्रिया: ।।१७६।।",
    gujarati:
      "અને તે સ્ત્રીઓની વાર્તા કયારેય ન કરવી અને ન સાંભળવી અને જે સ્થાનકને વિષે સ્ત્રીઓનો પગફેર હોય તે સ્થાનકને વિષે સ્નાનાદિક ક્રિયા કરવા ન જવું. ।।૧૭૬।।",
  },
  {
    number: 177,
    sanskrit:
      "देवताप्रतिमा हित्वा लेख्या काष्ठादिजापि वा ।<br>न योषित्प्रतिमा स्पृश्या न वीक्ष्या बुद्धिपूर्वकम्‌ ।।१७७।।",
    gujarati:
      "અને દેવતાની પ્રતિમા વિના બીજી જે સ્ત્રીની પ્રતિમા, ચિત્રની અથવા કાષ્ઠાદિકની હોય તેનો સ્પર્શ ન કરવો અને જાણીને તો તે પ્રતિમાને જોવી પણ નહિ. ।।૧૭૭।।",
  },
  {
    number: 178,
    sanskrit:
      "न स्त्रीप्रतिकृति: कार्या न स्पृश्यं योषितोंऽशुकम्‌ ।<br>न वीक्ष्यं मैथुनपरं प्राणिमात्रं च तैर्धिया ।।१७८।।",
    gujarati:
      "અને તે નૈષ્ઠિક બ્રહ્મચારી તેમણે સ્ત્રીની પ્રતિમા ન કરવી અને સ્ત્રીએ propriaપોતાના શરીર ઉપર ધારેલું જે વસ્ત્ર તેને અડવું નહિ અને મૈથુનાસક્ત એવાં જે પશુપક્ષ્યાદિક પ્રાણીમાત્ર તેમને જાણીને જોવાં નહિ. ।।૧૭૮।।",
  },
  {
    number: 179,
    sanskrit:
      "न स्पृश्यो नेक्षणीयश्च नारीवेषधर: पुमान्‌ ।<br>न कार्यं स्त्री: समुद्दिश्य भगवद्‌गुणकीर्तनम्‌ ।।१७९।।",
    gujarati:
      "અને સ્ત્રીના વેષને ધરી રહ્યો એવો જે પુરુષ તેને અડવું નહિ અને તેની સામું જોવું નહિ અને તે સાથે બોલવું નહિ અને સ્ત્રીનો ઉદ્દેશ કરીને ભગવાનની કથાવાર્તા કીર્તન પણ ન કરવાં. ।।૧૭૯।।",
  },
  {
    number: 180,
    sanskrit:
      "ब्रह्मचर्यव्रतत्यागपरं वाक्यं गुरोरपि ।<br>तैर्न मान्यं सदा स्थेयं धीरैस्तुष्टैरमानिभि: ।।१८०।।",
    gujarati:
      "અને તે નૈષ્ઠિક બ્રહ્મચારી તેઓએ propriaપોતાના બ્રહ્મચર્ય વ્રતનો ત્યાગ થાય એવું જે વચન તે તો propriaપોતાના ગુરુનું પણ ન માનવું ને સદાકાળ ધીરજવાન રહેવું અને સંતોષે યુક્ત રહેવું ને માને રહિત રહેવું. ।।૧૮૦।।",
  },
  {
    number: 181,
    sanskrit:
      "स्वातिनैकट्यमायान्ती प्रसभं वनिता तु या ।<br>निवारणीया सा भाष्य तिरस्कृत्यापि वा द्रुतम्‌ ।।१८१।।",
    gujarati:
      "અને બળાત્કારે કરીને propriaપોતાને અતિશય સમીપે આવતી એવી જે સ્ત્રી તેને બોલીને અથવા તિરસ્કાર કરીને પણ તુરત નિવારવી પણ સમીપે આવવા દેવી નહિ. ।।૧૮૧।।",
  },
  {
    number: 182,
    sanskrit:
      "प्राणापद्युपपन्नायां स्त्रीणां स्वेषां च वा क्वचित्‌ ।<br>तदा स्पृष्ट्‌वापि तद्रक्षा कार्या सम्भाष्य ताश्च वा ।।१८२।।",
    gujarati:
      "અને જો કયારેય સ્ત્રીઓનો અથવા propriaપોતાનો પ્રાણ નાશ થાય એવો આપત્કાળ આવી પડે ત્યારે તો તે સ્ત્રીઓને અડીને અથવા તે સાથે બોલીને પણ તે સ્ત્રીઓની રક્ષા કરવી અને propriaપોતાની પણ રક્ષા કરવી. ।।૧૮૨।।",
  },
  {
    number: 183,
    sanskrit:
      "तैलाभ्यङ्गो न कर्तव्यो न धार्यं चायुधं तथा ।<br>वेषो न विकृतो धार्यो जेतव्या रसना च तै: ।।१८३।।",
    gujarati:
      "અને તે નૈષ્ઠિક બ્રહ્મચારી તેઓએ propriaપોતાને શરીરે તૈલમર્દન ન કરવું ને આયુધ ન ધારવું ને ભયંકર એવો જે વેષ તે ન ધારવો અને રસના ઈંદ્રિયને જીતવી. ।।૧૮૩।।",
  },
  {
    number: 184,
    sanskrit:
      "परिवेषणकर्त्री स्याद्यत्र स्त्री विप्रवेश्मनि ।<br>न गम्यं तत्र भिक्षार्थं गन्तव्यमितरत्र तु ।।१८४।।",
    gujarati:
      "અને જે બ્રાહ્મણના ઘરને વિષે સ્ત્રી પીરસનારી હોય તેને ઘેર ભિક્ષા કરવા જવું નહિ ને જ્યાં પુરુષ પીરસનારો હોય ત્યાં જવું. ।।૧૮૪।।",
  },
  {
    number: 185,
    sanskrit:
      "अभ्यासो वेदशास्त्राणां कार्यश्च गुरुसेवनम्‌ ।<br>वर्ज्य: स्त्रीणामिव स्रैणपुंसां सङ्गश्च तै: सदा ।।१८५।।",
    gujarati:
      "અને તે નૈષ્ઠિક બ્રહ્મચારી તેઓએ વેદશાસ્ત્રનો અભ્યાસ કરવો ને ગુરુની સેવા કરવી ને સ્ત્રીઓની પેઠે જ સ્ત્રૈણ પુરુષનો સંગ જે તે સર્વકાળે વજર્વો. ।।૧૮૫।।",
  },
  {
    number: 186,
    sanskrit:
      "चर्मवारि न वै पेयं जात्या विप्रेण केनचित्‌ ।<br>पलाण्डुलशुनाद्यं च तेन भक्ष्यं न सर्वथा ।।१८६।।",
    gujarati:
      "અને જાતિએ કરીને જે બ્રાહ્મણ હોય તે કોઈએ પણ ચર્મવારિ ન પીવું ને ડુંગળી ને લસણ આદિક જે અભક્ષ્ય વસ્તુ તે બ્રાહ્મણ જાતિ હોય તેને કોઈ પ્રકારે ન ખાવું. ।।૧૮૬।।",
  },
  {
    number: 187,
    sanskrit:
      "स्नानं सन्ध्यां च गायत्रीजपं श्रीविष्णुपूजनम्‌ ।<br>अकृत्वा वैश्वदेवं च कर्तव्यं नैव भोजनम्‌ ।।१८७।।",
    gujarati:
      "અને જે બ્રાહ્મણ હોય તેણે સ્નાન, સંધ્યા, ગાયત્રીનો જપ, શ્રીવિષ્ણુની પૂજા અને વૈશ્વદેવ એટલાં વાનાં કર્યા વિના ભોજન કરવું જ નહિ. ।।૧૮૭।।",
  },
  {
    number: 188,
    sanskrit:
      "साधवो येऽथ तै: सर्वैर्नैष्ठिकब्रह्मचारिवत्‌ ।<br>स्त्रीस्त्रैणसङ्गादि वर्ज्यं जेतव्याश्चान्तरारय: ।।१८८।।",
    gujarati:
      "હવે સાધુના જે વિશેષ ધર્મ તે કહીએ છીએ. અમારે આશ્રિત જે સર્વે સાધુ તેઓએ નૈષ્ઠિક બ્રહ્મચારીની પેઠે સ્ત્રીઓનાં દર્શન ભાષણાદિક પ્રસંગનો ત્યાગ કરવો તથા સ્ત્રૈણ પુરુષના પ્રસંગાદિકનો ત્યાગ કરવો અને અંતઃશત્રુ જે કામ, ક્રોધ, લોભ અને માન આદિક તેમને જીતવા. ।।૧૮૮।।",
  },
  {
    number: 189,
    sanskrit:
      "सर्वेन्द्रियाणि जेयानि रसना तु विशेषत: ।<br>न द्रव्यसङ्ग्रह: कार्य: कारणीयो न केनचित्‌ ।।१८९।।",
    gujarati:
      "અને સર્વે જે ઈંદ્રિયો તે જીતવી ને રસના ઈંદ્રિયને તો વિશેષ કરીને જીતવી અને દ્રવ્યનો સંગ્રહ propriaપોતે કરવો નહિ ને કોઈ બીજા પાસે પણ કરાવવો નહિ. ।।૧૮૯।।",
  },
  {
    number: 190,
    sanskrit:
      "न्यासो रक्ष्यो न कस्यापि धैर्यं त्याज्यं न कर्हिचित्‌ ।<br>न प्रवेशयितव्या च स्वावासे स्त्री कदाचन ।।१९०।।",
    gujarati:
      "અને કોઈની થાપણ ન રાખવી અને કયારેય પણ ધીરજતાનો ત્યાગ ન કરવો અને propriaપોતાના ઉતારાની જાયગા બંધીની હોય તો તેને વિષે કયારેય પણ સ્ત્રીનો પ્રવેશ થવા દેવો નહિ. ।।૧૯૦।।",
  },
  {
    number: 191,
    sanskrit:
      "न च सङ्घं विना रात्रौ चलितव्यमनापदि ।<br>एकाकिभिर्न गन्तव्यं तथा क्वापि विनापदम्‌ ।।१९१।।",
    gujarati:
      "અને તે સાધુ તેઓએ આપત્કાળ પડયા વિના રાત્રિને વિષે સંગસોબત વિના ચાલવું નહિ તથા આપત્કાળ પડયા વિના કયારેય પણ એકલા ચાલવું નહિ. ।।૧૯૧।।",
  },
  {
    number: 192,
    sanskrit:
      "अनर्घ्यं चित्रितं वास: कुसुम्भाद्यैश्च रञ्जितम्‌ ।<br>न धार्यं च महावस्त्रं प्राप्तमन्येच्छयापि तत्‌ ।।१९२।।",
    gujarati:
      "અને જે વસ્ત્ર બહુ મૂલ્યવાળું હોય તથા ચિત્ર વિચિત્ર ભાત્યનું હોય તથા કસુંબાદિક જે રંગ, તેને કરીને રંગેલું હોય તથા શાલ દુશાલા હોય ને તે જો બીજાની ઈચ્છાએ કરીને propriaપોતાને પ્રાપ્ત થયું હોય તો પણ તે વસ્ત્ર propriaપોતાને પહેરવું ઓઢવું નહિ. ।।૧૯૨।।",
  },
  {
    number: 193,
    sanskrit:
      "भिक्षां सभां विना नैव गन्तव्यं गृहिणो गृहम्‌ ।<br>व्यर्थ: कालो न नेतव्यो भक्तिं भगवतो विना ।।१९३।।",
    gujarati:
      "અને ભિક્ષા તથા સભા પ્રસંગ એ બે કાર્ય વિના ગૃહસ્થના ઘર પ્રત્યે જવું નહિ અને ભગવાનની જે નવ પ્રકારની ભક્તિ તે વિના વ્યર્થ કાળ નિર્ગમવો નહિ. નિરંતર ભક્તિ કરીને જ કાળ નિર્ગમવો. ।।૧૯૩।।",
  },
  {
    number: 194,
    sanskrit:
      "पुमानेव भवेद्यत्र पक्वान्नपरिवेषण: ।<br>ईक्षणादि भवेन्नैव यत्र स्त्रीणां च सर्वथा ।।१९४।।",
    gujarati:
      "અને જે ગૃહસ્થના ઘરને વિષે રાંધેલ અન્નનો પીરસનારો પુરુષ જ હોય તથા સ્ત્રીઓનો દર્શનાદિક પ્રસંગ કોઈ રીતે થાય એમ ન હોય. ।।૧૯૪।।",
  },
  {
    number: 195,
    sanskrit:
      "तत्र गृहिगृहे भोक्तुं गन्तव्यं साधुभिर्मम ।<br>अन्यथामान्नमर्थित्वा पाक: कार्य: स्वयं च तै: ।।१९५।।",
    gujarati:
      "તેવી રીતનું જે ગૃહસ્થનું ઘર, તે પ્રત્યે અમારા સાધુ, તેઓએ જમવા જવું અને એ જણાવ્યું તેવું ન હોય તો કાચું અન્ન માગીને propriaપોતાના હાથે રસોઈ કરવી ને ભગવાનને નૈવેદ્ય ધરીને જમવું. ।।૧૯૫।।",
  },
  {
    number: 196,
    sanskrit:
      "आर्षभो भरत: पूर्वं जडविप्रो यथा भुवि ।<br>अवर्ततात्र परमहंसैर्वृत्यं तथैव तै: ।।१९६।।",
    gujarati:
      "અને પૂર્વે ઋષભદેવ ભગવાનના પુત્ર, જે ભરતજી તે જે તે પૃથ્વીને વિષે જડ બ્રાહ્મણ થકા જેમ વર્તતા હતા તેમ જ પરમહંસ એવા જે અમારા સાધુ તેઓએ વર્તવું. ।।૧૯૬।।",
  },
  {
    number: 197,
    sanskrit:
      "वर्णिभि: साधुभिश्चैतैर्वर्जनीयं प्रयत्नत: ।<br>ताम्बूलस्याहिफेनस्य तमालादेश्च भक्षणम्‌ ।।१९७।।",
    gujarati:
      "અને નૈષ્ઠિક બ્રહ્મચારી ને એ સાધુ તેઓએ તાંબૂલ તથા અફીણ તથા તમાકુ ઈત્યાદિકનું ભક્ષણ તે યત્ને કરીને વજર્વું. ।।૧૯૭।।",
  },
  {
    number: 198,
    sanskrit:
      "संस्कारेषु न भोक्तव्यं गर्भाधानमुखेषु तै: ।<br>प्रेतश्राद्धेषु सर्वेषु श्राद्धे च द्वादशाहिके ।।१९८।।",
    gujarati:
      "અને તે નૈષ્ઠિક બ્રહ્મચારી ને સાધુ તેઓએ ગર્ભાધાન આદિક જે સંસ્કાર તેમને વિષે જમવું નહિ તથા એકાદશાહ પર્યંત જે પ્રેતશ્રાદ્ધ તેમને વિષે જમવું નહિ તથા દ્વાદશાહ શ્રાદ્ધને વિષે જમવું નહિ. ।।૧૯૮।।",
  },
  {
    number: 199,
    sanskrit:
      "दिवा स्वापो न कर्तव्यो रोगाद्यापदमन्तરા ।<br>ग्राम्यवार्ता न कार्या च न श्रव्या बुद्धिपूर्वकम्‌ ।।१९९।।",
    gujarati:
      "અને રોગાદિક આપત્કાળ પડયા વિના દિવસે સૂવું નહિ અને ગ્રામ્યવાર્તા કરવી નહિ અને જાણીને સાંભળવી નહિ. ।।૧૯૯।।",
  },
  {
    number: 200,
    sanskrit:
      "स्वप्यं न तैश्च खट्‌वायां विना रोगादिमापदम्‌ ।<br>निश्छद्म वर्तितव्यं च साधूनामग्रत: सदा ।।२००।।",
    gujarati:
      "અને તે નૈષ્ઠિક બ્રહ્મચારી અને સાધુ તેઓએ રોગાદિક આપત્કાળ પડયા વિના ખાટલા ઉપર સૂવું નહિ અને સાધુની આગળ તો નિરંતર નિષ્કપટપણે વર્તવું. ।।૨૦૦।।",
  },
  {
    number: 201,
    sanskrit:
      "गालिदानं ताडनं च कृतं कुमतिभिर्जनै: ।<br>क्षन्तव्यमेव सर्वेषां चिन्तनीयं हितं च तै: ।।२०१।।",
    gujarati:
      "અને તે સાધુ ને બ્રહ્મચારી તેઓએ કોઈક કુમતિવાળા દુષ્ટજન હોય ને તે propriaપોતાને ગાળ દે અથવા મારે તો તે સહન જ કરવું પણ તેને સામી ગાળ ન દેવી ને મારવો નહિ અને તેનું જેમ હિત થાય તેમજ મનમાં ચિંતવન કરવું પણ તેનું ભૂંડું થાય એવો સંકલ્પ પણ ન કરવો. ।।૨૦૧।।",
  },
  {
    number: 202,
    sanskrit:
      "दूतकर्म न कर्तव्यं पैशुनं चारकर्म च ।<br>देहेऽहन्ता च ममता न कार्या स्वजनादिषु ।।२०२।।",
    gujarati:
      "અને કોઈનું દૂતપણું ન કરવું તથા ચાડિયાપણું ન કરવું તથા કોઈના ચારચક્ષુ ન થવું અને દેહને વિષે અહંબુદ્ધિ ન કરવી ને સ્વજનાદિકને વિષે મમતા ન કરવી. ।।૨૦૨।।",
  },
  {
    number: 203,
    sanskrit:
      "इति संक्षेपतो धर्मा:सर्वेषां लिखिता मया ।<br>साम्प्रदायिकग्रन्थेभ्यो ज्ञेय एषां तु विस्तर: ।।२०३।।",
    gujarati:
      "અને અમારા આશ્રિત એવા જે સત્સંગી બાઈ ભાઈ સર્વે તેમના જે સામાન્ય ધર્મ અને વિશેષ ધર્મ તે જે તે સંક્ષેપે કરીને આવી રીતે અમે લખ્યા છે અને આ ધર્મનો જે વિસ્તાર તેતો અમારા સંપ્રદાયના જે ગ્રંથ તે થકી જાણવો. ।।૨૦૩।।",
  },
  {
    number: 204,
    sanskrit:
      "सच्छास्त्राणां समुद्धृत्य सर्वेषां सारमात्मना ।<br>पत्रीयं लिखिता नृणामभीष्टफलदायिनी ।।२०४।।",
    gujarati:
      "અને સર્વે જે સચ્છાસ્ત્ર તેનો જે સાર તેને અમે અમારી બુદ્ધિએ કરીને ઉદ્ધારીને આ શિક્ષાપત્રી જેતે લખી છે તે કેવી છે તો સર્વે મનુષ્ય માત્રને મનવાંછિત ફળની દેનારી છે. ।।૨૦૪।।",
  },
  {
    number: 205,
    sanskrit:
      "इमामेव ततो नित्यमनुसृत्य ममाश्रितै: ।<br>यतात्मभिर्वर्तितव्यं न तु स्वैरं कदाचन ।।२०५।।",
    gujarati:
      "એ હેતુ માટે અમારા આશ્રિત જે સત્સંગી તેઓએ સાવધાનપણે કરીને નિત્ય પ્રત્યે આ શિક્ષાપત્રીને અનુસરીને જ વર્તવું પણ propriપોતાના મનને જાણે તો કયારેય ન વર્તવું. ।।૨૦૫।।",
  },
  {
    number: 206,
    sanskrit:
      "वर्तिष्यन्ते य इत्थं हि पुरुषा योषितस्तथा ।<br>ते धर्मादि चतुर्वर्गसिद्धिं प्राप्स्यन्ति निश्चितम्‌ ।।२०६।।",
    gujarati:
      "અને જે અમારા આશ્રિત પુરુષ ને સ્ત્રીઓ તે જેતે આ શિક્ષાપત્રી પ્રમાણે વર્તશે તો તે ધર્મ, અર્થ, કામ ને મોક્ષ એ ચાર પુરુષાર્થની સિદ્ધિને નિશ્ચય પામશે. ।।૨૦૬।।",
  },
  {
    number: 207,
    sanskrit:
      "नेत्थं य आचरिष्यन्ति ते त्वस्मत्सम्प्रदायत: ।<br>बहिर्भूता इति ज्ञेयं स्त्रीपुंसै: साम्प्रदायिकै: ।।२०७।।",
    gujarati:
      "અને જે બાઈ ભાઈ આ શિક્ષાપત્રી પ્રમાણે નહિ વર્તે તે તો અમારા સંપ્રદાય થકી બાહેર છે. એમ અમારા સંપ્રદાયવાળા સ્ત્રી પુરુષ તેઓએ જાણવું. ।।૨૦૭।।",
  },
  {
    number: 208,
    sanskrit:
      "शिक्षापत्र्या: प्रतिदिनं पाठोऽस्या मदुपाश्रितै: ।<br>कर्तव्योऽनक्षरज्ञैस्तु श्रवणं कार्यमादरात्‌ ।।२०८।।",
    gujarati:
      "અને અમારા જે આશ્રિત સત્સંગી તેઓએ આ શિક્ષાપત્રીનો નિત્ય પ્રત્યે પાઠ કરવો અને જેમને ભણતાં આવડતું ન હોય તેઓએ તો આદર થકી આ શિક્ષાપત્રીનું શ્રવણ કરવું. ।।૨૦૮।।",
  },
  {
    number: 209,
    sanskrit:
      "वक्त्रभावे तु पूजैव कार्याऽस्या: प्रतिवासरम्‌। ।<br>मद्रूपमिति मद्वाणी मान्येयं परमादरात्‌ ।।२०९।।",
    gujarati:
      "અને આ શિક્ષાપત્રીને વાંચી સંભળાવે એવો કોઈ ન હોય, ત્યારે તો નિત્યપ્રત્યે આ શિક્ષાપત્રીની પૂજા કરવી અને આ જે અમારી વાણી તે અમારું સ્વરૂપ છે એ રીતે પરમ આદર થકી માનવી. ।।૨૦૯।।",
  },
  {
    number: 210,
    sanskrit:
      "युक्ताय सम्पदा दैव्या दातव्येयं तु पत्रिका ।<br>आसुर्या सम्पदाढ्‌याय पुंसे देया न कर्हिचित्‌ ।।२१०।।",
    gujarati:
      "અને આ જે અમારી શિક્ષાપત્રી તે જે તે દૈવી સંપદાએ કરીને યુક્ત જે જન હોય તેને આપવી અને જે જન આસુરી સંપદાએ કરીને યુક્ત હોય તેને તો કયારેય ન આપવી. ।।૨૧૦।।",
  },
  {
    number: 211,
    sanskrit:
      "विक्रमार्कशकस्याब्दे नेत्राष्टावसुभूमिते ।<br>वसन्ताद्या दिने शिक्षापत्रीयं लिखिता शुभा ।।२११।।",
    gujarati:
      "સંવત્‌ ૧૮૮૨ અઢારસો બ્યાસીના મહા સુદિ પંચમીને દિવસે આ શિક્ષાપત્રી અમે લખી છે તે પરમ કલ્યાણકારી છે. ।।૨૧૧।।",
  },
  {
    number: 212,
    sanskrit:
      "निजाश्रितानां सकलार्तिहन्ता सधर्मभक्तेरवनं विधाता ।<br>दाता सुखानां मनसेप्सितानां तनोतु कृष्णोऽखिलमङ्गलं न: ।।२१२।।",
    gujarati:
      "અને propriaપોતાના આશ્રિત જે ભક્તજન, તેમની જે સમગ્ર પીડા, તેના નાશ કરનારા એવા ને ધર્મે સહિત જે ભક્તિ, તેની રક્ષાના કરનારા એવા ને propriaપોતાના ભક્તજનને મનવાંછિત સુખના આપનારા, એવા જે શ્રીકૃષ્ણ ભગવાન તે જેતે અમારા સમગ્ર મંગળને વિસ્તારો. ।।૨૧૨।।",
  },
];
